export const easypayArea = [{
  "text": "广东省",
  "value": 1,
  "children": [{
    "text": "广州市",
    "value": 968,
    "children": [{
      "text": "番禺区",
      "value": 5811
    }, {
      "text": "从化区",
      "value": 5812
    }, {
      "text": "增城区",
      "value": 5813
    }, {
      "text": "荔湾区",
      "value": 5814
    }, {
      "text": "越秀区",
      "value": 5815
    }, {
      "text": "海珠区",
      "value": 5816
    }, {
      "text": "天河区",
      "value": 5817
    }, {
      "text": "白云区",
      "value": 5818
    }, {
      "text": "黄埔区",
      "value": 5819
    }, {
      "text": "花都区",
      "value": 6071
    }, {
      "text": "南沙区",
      "value": 6072
    }]
  }, {
    "text": "韶关市",
    "value": 969,
    "children": [{
      "text": "武江区",
      "value": 5821
    }, {
      "text": "始兴县",
      "value": 5822
    }, {
      "text": "南雄市",
      "value": 5823
    }, {
      "text": "仁化县",
      "value": 5824
    }, {
      "text": "乐昌市",
      "value": 5825
    }, {
      "text": "翁源县",
      "value": 5826
    }, {
      "text": "乳源瑶族自治县",
      "value": 5827
    }, {
      "text": "新丰县",
      "value": 5828
    }, {
      "text": "浈江区",
      "value": 5829
    }, {
      "text": "曲江区",
      "value": 5831
    }]
  }, {
    "text": "深圳市",
    "value": 970,
    "children": [{
      "text": "罗湖区",
      "value": 5841
    }, {
      "text": "福田区",
      "value": 5842
    }, {
      "text": "南山区",
      "value": 5843
    }, {
      "text": "龙岗区",
      "value": 5844
    }, {
      "text": "宝安区",
      "value": 5845
    }, {
      "text": "盐田区",
      "value": 5846
    }, {
      "text": "龙华区",
      "value": 5848
    }, {
      "text": "坪山区",
      "value": 5849
    }, {
      "text": "光明区",
      "value": 5854
    }]
  }, {
    "text": "珠海市",
    "value": 971,
    "children": [{
      "text": "斗门区",
      "value": 5851
    }, {
      "text": "香洲区（横琴新区）",
      "value": 5852
    }, {
      "text": "金湾区",
      "value": 5853
    }]
  }, {
    "text": "汕头市",
    "value": 972,
    "children": [{
      "text": "南澳县",
      "value": 5863
    }, {
      "text": "龙湖区",
      "value": 5864
    }, {
      "text": "金平区",
      "value": 5865
    }, {
      "text": "澄海区",
      "value": 5866
    }, {
      "text": "濠江区",
      "value": 5867
    }, {
      "text": "潮阳区",
      "value": 5868
    }, {
      "text": "潮南区",
      "value": 5869
    }]
  }, {
    "text": "佛山市",
    "value": 973,
    "children": [{
      "text": "三水区",
      "value": 5881
    }, {
      "text": "南海区",
      "value": 5882
    }, {
      "text": "顺德区",
      "value": 5883
    }, {
      "text": "禅城区",
      "value": 5884
    }, {
      "text": "高明区",
      "value": 5885
    }]
  }, {
    "text": "江门市",
    "value": 974,
    "children": [{
      "text": "蓬江区",
      "value": 5891
    }, {
      "text": "台山市",
      "value": 5892
    }, {
      "text": "恩平市",
      "value": 5893
    }, {
      "text": "开平市",
      "value": 5894
    }, {
      "text": "鹤山市",
      "value": 5895
    }, {
      "text": "江海区",
      "value": 5896
    }, {
      "text": "新会区",
      "value": 5897
    }]
  }, {
    "text": "湛江市",
    "value": 975,
    "children": [{
      "text": "吴川市",
      "value": 5911
    }, {
      "text": "廉江市",
      "value": 5912
    }, {
      "text": "遂溪县",
      "value": 5913
    }, {
      "text": "雷州市",
      "value": 5914
    }, {
      "text": "徐闻县",
      "value": 5915
    }, {
      "text": "赤坎区",
      "value": 5916
    }, {
      "text": "霞山区",
      "value": 5917
    }, {
      "text": "坡头区",
      "value": 5918
    }, {
      "text": "麻章区",
      "value": 5919
    }]
  }, {
    "text": "茂名市",
    "value": 976,
    "children": [{
      "text": "信宜市",
      "value": 5921
    }, {
      "text": "高州市",
      "value": 5922
    }, {
      "text": "电白区",
      "value": 5923
    }, {
      "text": "化州市",
      "value": 5924
    }, {
      "text": "茂南区",
      "value": 5925
    }]
  }, {
    "text": "肇庆市",
    "value": 977,
    "children": [{
      "text": "高要区",
      "value": 5931
    }, {
      "text": "四会市",
      "value": 5932
    }, {
      "text": "广宁县",
      "value": 5933
    }, {
      "text": "怀集县",
      "value": 5934
    }, {
      "text": "封开县",
      "value": 5935
    }, {
      "text": "德庆县",
      "value": 5936
    }, {
      "text": "端州区",
      "value": 5937
    }, {
      "text": "鼎湖区",
      "value": 5938
    }]
  }, {
    "text": "惠州市",
    "value": 978,
    "children": [{
      "text": "博罗县",
      "value": 5952
    }, {
      "text": "惠东县",
      "value": 5953
    }, {
      "text": "龙门县",
      "value": 5954
    }, {
      "text": "惠城区",
      "value": 5955
    }, {
      "text": "惠阳区",
      "value": 5956
    }]
  }, {
    "text": "梅州市",
    "value": 979,
    "children": [{
      "text": "梅江区",
      "value": 5961
    }, {
      "text": "大埔县",
      "value": 5962
    }, {
      "text": "丰顺县",
      "value": 5963
    }, {
      "text": "五华县",
      "value": 5964
    }, {
      "text": "兴宁市",
      "value": 5965
    }, {
      "text": "平远县",
      "value": 5966
    }, {
      "text": "蕉岭县",
      "value": 5967
    }, {
      "text": "梅县区",
      "value": 5968
    }]
  }, {
    "text": "汕尾市",
    "value": 980,
    "children": [{
      "text": "海丰县",
      "value": 5971
    }, {
      "text": "陆丰市",
      "value": 5972
    }, {
      "text": "陆河县",
      "value": 5973
    }, {
      "text": "城  区",
      "value": 5974
    }]
  }, {
    "text": "河源市",
    "value": 981,
    "children": [{
      "text": "紫金县",
      "value": 5981
    }, {
      "text": "龙川县",
      "value": 5982
    }, {
      "text": "连平县",
      "value": 5983
    }, {
      "text": "和平县",
      "value": 5984
    }, {
      "text": "东源县",
      "value": 5985
    }, {
      "text": "源城区",
      "value": 5986
    }]
  }, {
    "text": "阳江市",
    "value": 982,
    "children": [{
      "text": "阳西县",
      "value": 5991
    }, {
      "text": "阳春市",
      "value": 5992
    }, {
      "text": "阳东区",
      "value": 5993
    }, {
      "text": "江城区",
      "value": 5994
    }]
  }, {
    "text": "清远市",
    "value": 983,
    "children": [{
      "text": "清新区",
      "value": 6017
    }, {
      "text": "佛冈县",
      "value": 6011
    }, {
      "text": "英德市",
      "value": 6012
    }, {
      "text": "阳山县",
      "value": 6013
    }, {
      "text": "连州市",
      "value": 6014
    }, {
      "text": "连山壮族瑶族自治县",
      "value": 6015
    }, {
      "text": "连南瑶族自治县",
      "value": 6016
    }, {
      "text": "清城区",
      "value": 6018
    }]
  }, {
    "text": "东莞市",
    "value": 984,
    "children": [{
      "text": "东莞市",
      "value": 6020
    }]
  }, {
    "text": "中山市",
    "value": 985,
    "children": []
  }, {
    "text": "潮州市",
    "value": 986,
    "children": [{
      "text": "湘桥区",
      "value": 6043
    }, {
      "text": "潮安区",
      "value": 6041
    }, {
      "text": "饶平县",
      "value": 6042
    }]
  }, {
    "text": "揭阳市",
    "value": 987,
    "children": [{
      "text": "揭东区",
      "value": 6056
    }, {
      "text": "揭西县",
      "value": 6052
    }, {
      "text": "惠来县",
      "value": 6053
    }, {
      "text": "普宁市",
      "value": 6054
    }, {
      "text": "榕城区",
      "value": 6055
    }]
  }, {
    "text": "云浮市",
    "value": 988,
    "children": [{
      "text": "罗定市",
      "value": 6064
    }, {
      "text": "新兴县",
      "value": 6061
    }, {
      "text": "郁南县",
      "value": 6062
    }, {
      "text": "云安区",
      "value": 6063
    }, {
      "text": "云城区",
      "value": 6065
    }]
  }]
}, {
  "text": "广西壮族自治区",
  "value": 2,
  "children": [{
    "text": "南宁市",
    "value": 989,
    "children": [{
      "text": "西乡塘区",
      "value": 6114
    }, {
      "text": "兴宁区",
      "value": 6111
    }, {
      "text": "武鸣县",
      "value": 6112
    }, {
      "text": "江南区",
      "value": 6113
    }, {
      "text": "良庆区",
      "value": 6115
    }, {
      "text": "邕宁区",
      "value": 6116
    }, {
      "text": "青秀区",
      "value": 6117
    }, {
      "text": "横  县",
      "value": 6122
    }, {
      "text": "宾阳县",
      "value": 6123
    }, {
      "text": "隆安县",
      "value": 6125
    }, {
      "text": "马山县",
      "value": 6126
    }, {
      "text": "上林县",
      "value": 6124
    }]
  }, {
    "text": "柳州市",
    "value": 990,
    "children": [{
      "text": "柳江区",
      "value": 6141
    }, {
      "text": "柳城县",
      "value": 6142
    }, {
      "text": "城中区",
      "value": 6143
    }, {
      "text": "柳南区",
      "value": 6145
    }, {
      "text": "柳北区",
      "value": 6146
    }, {
      "text": "鹿寨县",
      "value": 6152
    }, {
      "text": "融安县",
      "value": 6156
    }, {
      "text": "三江侗族自治县",
      "value": 6157
    }, {
      "text": "鱼峰区",
      "value": 6144
    }, {
      "text": "融水苗族自治县",
      "value": 6158
    }]
  }, {
    "text": "桂林市",
    "value": 991,
    "children": [{
      "text": "阳朔县",
      "value": 6171
    }, {
      "text": "秀峰区",
      "value": 6172
    }, {
      "text": "叠彩区",
      "value": 6173
    }, {
      "text": "象山区",
      "value": 6174
    }, {
      "text": "七星区",
      "value": 6175
    }, {
      "text": "雁山区",
      "value": 6176
    }, {
      "text": "灵川县",
      "value": 6181
    }, {
      "text": "全州县",
      "value": 6182
    }, {
      "text": "兴安县",
      "value": 6183
    }, {
      "text": "永福县",
      "value": 6184
    }, {
      "text": "灌阳县",
      "value": 6185
    }, {
      "text": "资源县",
      "value": 6187
    }, {
      "text": "平乐县",
      "value": 6188
    }, {
      "text": "荔浦市",
      "value": 6189
    }, {
      "text": "恭城瑶族自治县",
      "value": 6191
    }, {
      "text": "临桂区",
      "value": 6177
    }, {
      "text": "龙胜各族自治县",
      "value": 6186
    }]
  }, {
    "text": "梧州市",
    "value": 992,
    "children": [{
      "text": "苍梧县",
      "value": 6211
    }, {
      "text": "万秀区",
      "value": 6212
    }, {
      "text": "龙圩区",
      "value": 6214
    }, {
      "text": "岑溪市",
      "value": 6221
    }, {
      "text": "藤  县",
      "value": 6222
    }, {
      "text": "蒙山县",
      "value": 6224
    }, {
      "text": "长洲区",
      "value": 6213
    }]
  }, {
    "text": "北海市",
    "value": 993,
    "children": [{
      "text": "合浦县",
      "value": 6231
    }, {
      "text": "银海区",
      "value": 6233
    }, {
      "text": "铁山港区",
      "value": 6234
    }, {
      "text": "海城区",
      "value": 6232
    }]
  }, {
    "text": "玉林市",
    "value": 994,
    "children": [{
      "text": "玉州区",
      "value": 6241
    }, {
      "text": "福绵区",
      "value": 6242
    }, {
      "text": "北流市",
      "value": 6246
    }, {
      "text": "陆川县",
      "value": 6247
    }, {
      "text": "博白县",
      "value": 6248
    }, {
      "text": "兴业县",
      "value": 6249
    }, {
      "text": "容　县",
      "value": 6245
    }]
  }, {
    "text": "百色市",
    "value": 995,
    "children": [{
      "text": "右江区",
      "value": 6261
    }, {
      "text": "田阳县",
      "value": 6262
    }, {
      "text": "田东县",
      "value": 6263
    }, {
      "text": "平果县",
      "value": 6264
    }, {
      "text": "德保县",
      "value": 6265
    }, {
      "text": "靖西市",
      "value": 6266
    }, {
      "text": "那坡县",
      "value": 6267
    }, {
      "text": "凌云县",
      "value": 6268
    }, {
      "text": "乐业县",
      "value": 6269
    }, {
      "text": "田林县",
      "value": 6271
    }, {
      "text": "隆林各族自治县",
      "value": 6272
    }, {
      "text": "西林县",
      "value": 6273
    }]
  }, {
    "text": "河池市",
    "value": 996,
    "children": [{
      "text": "金城江区",
      "value": 6281
    }, {
      "text": "宜州区",
      "value": 6282
    }, {
      "text": "罗城仫佬族自治县",
      "value": 6283
    }, {
      "text": "环江毛南族自治县",
      "value": 6284
    }, {
      "text": "南丹县",
      "value": 6285
    }, {
      "text": "天峨县",
      "value": 6286
    }, {
      "text": "凤山县",
      "value": 6287
    }, {
      "text": "东兰县",
      "value": 6288
    }, {
      "text": "巴马瑶族自治县",
      "value": 6289
    }, {
      "text": "都安瑶族自治县",
      "value": 6291
    }, {
      "text": "大化瑶族自治县",
      "value": 6292
    }]
  }, {
    "text": "钦州市",
    "value": 997,
    "children": [{
      "text": "钦南区",
      "value": 6311
    }, {
      "text": "钦北区",
      "value": 6312
    }, {
      "text": "灵山县",
      "value": 6314
    }, {
      "text": "浦北县",
      "value": 6315
    }]
  }, {
    "text": "防城港市",
    "value": 998,
    "children": [{
      "text": "上思县",
      "value": 6321
    }, {
      "text": "东兴市",
      "value": 6322
    }, {
      "text": "港口区",
      "value": 6323
    }, {
      "text": "防城区",
      "value": 6324
    }]
  }, {
    "text": "贵港市",
    "value": 999,
    "children": [{
      "text": "平南县",
      "value": 6331
    }, {
      "text": "桂平市",
      "value": 6332
    }, {
      "text": "港北区",
      "value": 6333
    }, {
      "text": "港南区",
      "value": 6334
    }, {
      "text": "覃塘区",
      "value": 6335
    }]
  }, {
    "text": "贺州市",
    "value": 1000,
    "children": [{
      "text": "昭平县",
      "value": 6341
    }, {
      "text": "钟山县",
      "value": 6342
    }, {
      "text": "富川瑶族自治县",
      "value": 6343
    }, {
      "text": "八步区",
      "value": 6344
    }, {
      "text": "平桂区",
      "value": 6345
    }]
  }, {
    "text": "来宾市",
    "value": 1001,
    "children": [{
      "text": "忻城县",
      "value": 6351
    }, {
      "text": "象州县",
      "value": 6352
    }, {
      "text": "武宣县",
      "value": 6353
    }, {
      "text": "金秀瑶族自治县",
      "value": 6354
    }, {
      "text": "合山市",
      "value": 6355
    }, {
      "text": "兴宾区",
      "value": 6356
    }]
  }, {
    "text": "崇左市",
    "value": 1002,
    "children": [{
      "text": "扶绥县",
      "value": 6361
    }, {
      "text": "宁明县",
      "value": 6362
    }, {
      "text": "龙州县",
      "value": 6363
    }, {
      "text": "大新县",
      "value": 6364
    }, {
      "text": "天等县",
      "value": 6365
    }, {
      "text": "凭祥市",
      "value": 6366
    }, {
      "text": "江州区",
      "value": 6367
    }]
  }]
}, {
  "text": "海南省",
  "value": 3,
  "children": [{
    "text": "海口市",
    "value": 1003,
    "children": [{
      "text": "秀英区",
      "value": 6411
    }, {
      "text": "龙华区",
      "value": 6412
    }, {
      "text": "琼山区",
      "value": 6413
    }, {
      "text": "美兰区",
      "value": 6414
    }]
  }, {
    "text": "三亚市",
    "value": 1004,
    "children": [{
      "text": "五指山市（省直辖）",
      "value": 6421
    }, {
      "text": "吉阳区",
      "value": 6422
    }, {
      "text": "文昌市（省直辖）",
      "value": 6423
    }, {
      "text": "琼海市（省直辖）",
      "value": 6424
    }, {
      "text": "万宁市（省直辖）",
      "value": 6425
    }, {
      "text": "定安县（省直辖）",
      "value": 6426
    }, {
      "text": "屯昌县（省直辖）",
      "value": 6427
    }, {
      "text": "澄迈县（省直辖）",
      "value": 6428
    }, {
      "text": "临高县（省直辖）",
      "value": 6429
    }, {
      "text": "儋州市（省直辖）",
      "value": 6431
    }, {
      "text": "白沙黎族自治县（省直辖）",
      "value": 6432
    }, {
      "text": "昌江黎族自治县（省直辖）",
      "value": 6433
    }, {
      "text": "东方市（省直辖）",
      "value": 6434
    }, {
      "text": "乐东黎族自治县（省直辖）",
      "value": 6435
    }, {
      "text": "陵水黎族自治县（省直辖）",
      "value": 6436
    }, {
      "text": "保亭黎族苗族自治县（省直辖）",
      "value": 6437
    }, {
      "text": "琼中黎族苗族自治县（省直辖）",
      "value": 6438
    }, {
      "text": "海棠区",
      "value": 6439
    }, {
      "text": "天涯区",
      "value": 6451
    }, {
      "text": "崖州区",
      "value": 6452
    }]
  }, {
    "text": "三沙市",
    "value": 1005,
    "children": []
  }]
}, {
  "text": "四川省",
  "value": 4,
  "children": [{
    "text": "成都市",
    "value": 1006,
    "children": [{
      "text": "金堂县",
      "value": 6511
    }, {
      "text": "双流区",
      "value": 6512
    }, {
      "text": "青羊区",
      "value": 6513
    }, {
      "text": "郫都区",
      "value": 6514
    }, {
      "text": "金牛区",
      "value": 6515
    }, {
      "text": "彭州市",
      "value": 6516
    }, {
      "text": "崇州市",
      "value": 6517
    }, {
      "text": "大邑县",
      "value": 6518
    }, {
      "text": "邛崃市",
      "value": 6519
    }, {
      "text": "蒲江县",
      "value": 6521
    }, {
      "text": "新津县",
      "value": 6522
    }, {
      "text": "都江堰市",
      "value": 6523
    }, {
      "text": "锦江区",
      "value": 6524
    }, {
      "text": "武侯区",
      "value": 6525
    }, {
      "text": "成华区",
      "value": 6526
    }, {
      "text": "龙泉驿区",
      "value": 6527
    }, {
      "text": "青白江区",
      "value": 6528
    }, {
      "text": "新都区",
      "value": 6529
    }, {
      "text": "温江区",
      "value": 6541
    }, {
      "text": "简阳市",
      "value": 6883
    }]
  }, {
    "text": "自贡市",
    "value": 1007,
    "children": [{
      "text": "荣　县",
      "value": 6551
    }, {
      "text": "富顺县",
      "value": 6552
    }, {
      "text": "自流井区",
      "value": 6553
    }, {
      "text": "贡井区",
      "value": 6554
    }, {
      "text": "大安区",
      "value": 6555
    }, {
      "text": "沿滩区",
      "value": 6556
    }]
  }, {
    "text": "攀枝花市",
    "value": 1008,
    "children": [{
      "text": "米易县",
      "value": 6561
    }, {
      "text": "盐边县",
      "value": 6562
    }, {
      "text": "东  区",
      "value": 6563
    }, {
      "text": "西  区",
      "value": 6564
    }, {
      "text": "仁和区",
      "value": 6565
    }]
  }, {
    "text": "泸州市",
    "value": 1009,
    "children": [{
      "text": "泸  县",
      "value": 6571
    }, {
      "text": "合江县",
      "value": 6572
    }, {
      "text": "叙永县",
      "value": 6574
    }, {
      "text": "古蔺县",
      "value": 6575
    }, {
      "text": "江阳区",
      "value": 6576
    }, {
      "text": "纳溪区",
      "value": 6577
    }, {
      "text": "龙马潭区",
      "value": 6578
    }]
  }, {
    "text": "德阳市",
    "value": 1010,
    "children": [{
      "text": "绵竹市",
      "value": 6581
    }, {
      "text": "中江县",
      "value": 6582
    }, {
      "text": "什邡市",
      "value": 6583
    }, {
      "text": "广汉市",
      "value": 6584
    }, {
      "text": "罗江区",
      "value": 6585
    }, {
      "text": "旌阳区",
      "value": 6586
    }]
  }, {
    "text": "绵阳市",
    "value": 1011,
    "children": [{
      "text": "三台县",
      "value": 6591
    }, {
      "text": "盐亭县",
      "value": 6592
    }, {
      "text": "安州区",
      "value": 6593
    }, {
      "text": "梓潼县",
      "value": 6594
    }, {
      "text": "北川羌族自治县",
      "value": 6595
    }, {
      "text": "平武县",
      "value": 6596
    }, {
      "text": "江油市",
      "value": 6597
    }, {
      "text": "涪城区",
      "value": 6598
    }, {
      "text": "游仙区",
      "value": 6599
    }]
  }, {
    "text": "广元市",
    "value": 1012,
    "children": [{
      "text": "旺苍县",
      "value": 6611
    }, {
      "text": "青川县",
      "value": 6612
    }, {
      "text": "剑阁县",
      "value": 6613
    }, {
      "text": "苍溪县",
      "value": 6614
    }, {
      "text": "利州区",
      "value": 6615
    }, {
      "text": "朝天区",
      "value": 6617
    }, {
      "text": "昭化区",
      "value": 6616
    }]
  }, {
    "text": "遂宁市",
    "value": 1013,
    "children": [{
      "text": "蓬溪县",
      "value": 6621
    }, {
      "text": "射洪县",
      "value": 6622
    }, {
      "text": "大英县",
      "value": 6623
    }, {
      "text": "船山区",
      "value": 6625
    }, {
      "text": "安居区",
      "value": 6624
    }]
  }, {
    "text": "内江市",
    "value": 1014,
    "children": [{
      "text": "市中区",
      "value": 6631
    }, {
      "text": "东兴区",
      "value": 6632
    }, {
      "text": "资中县",
      "value": 6635
    }, {
      "text": "隆昌市",
      "value": 6638
    }, {
      "text": "威远县",
      "value": 6634
    }]
  }, {
    "text": "乐山市",
    "value": 1015,
    "children": [{
      "text": "市中区",
      "value": 6651
    }, {
      "text": "沙湾区",
      "value": 6652
    }, {
      "text": "井研县",
      "value": 6654
    }, {
      "text": "夹江县",
      "value": 6655
    }, {
      "text": "五通桥区",
      "value": 6656
    }, {
      "text": "沐川县",
      "value": 6658
    }, {
      "text": "峨边彝族自治县",
      "value": 6662
    }, {
      "text": "马边彝族自治县",
      "value": 6663
    }, {
      "text": "峨眉山市",
      "value": 6664
    }, {
      "text": "犍为县",
      "value": 6653
    }, {
      "text": "金口河区",
      "value": 6657
    }]
  }, {
    "text": "宜宾市",
    "value": 1016,
    "children": [{
      "text": "叙州区",
      "value": 6712
    }, {
      "text": "南溪区",
      "value": 6713
    }, {
      "text": "江安县",
      "value": 6714
    }, {
      "text": "高  县",
      "value": 6716
    }, {
      "text": "筠连县",
      "value": 6717
    }, {
      "text": "珙  县",
      "value": 6718
    }, {
      "text": "兴文县",
      "value": 6719
    }, {
      "text": "翠屏区",
      "value": 6711
    }, {
      "text": "长宁县",
      "value": 6715
    }, {
      "text": "屏山县",
      "value": 6721
    }]
  }, {
    "text": "南充市",
    "value": 1017,
    "children": [{
      "text": "顺庆区",
      "value": 6731
    }, {
      "text": "高坪区",
      "value": 6732
    }, {
      "text": "南部县",
      "value": 6734
    }, {
      "text": "蓬安县",
      "value": 6738
    }, {
      "text": "仪陇县",
      "value": 6739
    }, {
      "text": "西充县",
      "value": 6742
    }, {
      "text": "阆中市",
      "value": 6743
    }, {
      "text": "营山县",
      "value": 6736
    }, {
      "text": "嘉陵区",
      "value": 6744
    }]
  }, {
    "text": "达州市",
    "value": 1018,
    "children": [{
      "text": "通川区",
      "value": 6751
    }, {
      "text": "达川区",
      "value": 6752
    }, {
      "text": "宣汉县",
      "value": 6753
    }, {
      "text": "万源市",
      "value": 6755
    }, {
      "text": "大竹县",
      "value": 6761
    }, {
      "text": "渠　县",
      "value": 6762
    }, {
      "text": "开江县",
      "value": 6754
    }]
  }, {
    "text": "雅安市",
    "value": 1019,
    "children": [{
      "text": "雨城区",
      "value": 6771
    }, {
      "text": "荥经县",
      "value": 6773
    }, {
      "text": "汉源县",
      "value": 6774
    }, {
      "text": "石棉县",
      "value": 6775
    }, {
      "text": "芦山县",
      "value": 6777
    }, {
      "text": "宝兴县",
      "value": 6778
    }, {
      "text": "名山区",
      "value": 6772
    }, {
      "text": "天全县",
      "value": 6776
    }]
  }, {
    "text": "阿坝藏族羌族自治州",
    "value": 1020,
    "children": [{
      "text": "理  县",
      "value": 6792
    }, {
      "text": "松潘县",
      "value": 6794
    }, {
      "text": "九寨沟县",
      "value": 6795
    }, {
      "text": "小金县",
      "value": 6797
    }, {
      "text": "马尔康市",
      "value": 6799
    }, {
      "text": "壤塘县",
      "value": 6801
    }, {
      "text": "阿坝县",
      "value": 6802
    }, {
      "text": "若尔盖县",
      "value": 6803
    }, {
      "text": "红原县",
      "value": 6804
    }, {
      "text": "汶川县",
      "value": 6791
    }, {
      "text": "茂  县",
      "value": 6793
    }, {
      "text": "金川县",
      "value": 6796
    }, {
      "text": "黑水县",
      "value": 6798
    }]
  }, {
    "text": "甘孜藏族自治州",
    "value": 1021,
    "children": [{
      "text": "康定县",
      "value": 6811
    }, {
      "text": "泸定县",
      "value": 6812
    }, {
      "text": "丹巴县",
      "value": 6813
    }, {
      "text": "九龙县",
      "value": 6814
    }, {
      "text": "雅江县",
      "value": 6815
    }, {
      "text": "道孚县",
      "value": 6816
    }, {
      "text": "炉霍县",
      "value": 6817
    }, {
      "text": "甘孜县",
      "value": 6818
    }, {
      "text": "新龙县",
      "value": 6819
    }, {
      "text": "德格县",
      "value": 6821
    }, {
      "text": "白玉县",
      "value": 6822
    }, {
      "text": "石渠县",
      "value": 6823
    }, {
      "text": "色达县",
      "value": 6824
    }, {
      "text": "理塘县",
      "value": 6825
    }, {
      "text": "巴塘县",
      "value": 6826
    }, {
      "text": "乡城县",
      "value": 6827
    }, {
      "text": "稻城县",
      "value": 6828
    }, {
      "text": "得荣县",
      "value": 6829
    }]
  }, {
    "text": "凉山彝族自治州",
    "value": 1022,
    "children": [{
      "text": "西昌市",
      "value": 6841
    }, {
      "text": "木里藏族自治县",
      "value": 6842
    }, {
      "text": "盐源县",
      "value": 6843
    }, {
      "text": "德昌县",
      "value": 6844
    }, {
      "text": "会理县",
      "value": 6845
    }, {
      "text": "会东县",
      "value": 6846
    }, {
      "text": "宁南县",
      "value": 6847
    }, {
      "text": "普格县",
      "value": 6848
    }, {
      "text": "布拖县",
      "value": 6849
    }, {
      "text": "金阳县",
      "value": 6851
    }, {
      "text": "昭觉县",
      "value": 6852
    }, {
      "text": "喜德县",
      "value": 6853
    }, {
      "text": "冕宁县",
      "value": 6854
    }, {
      "text": "越西县",
      "value": 6855
    }, {
      "text": "甘洛县",
      "value": 6856
    }, {
      "text": "美姑县",
      "value": 6857
    }, {
      "text": "雷波县",
      "value": 6858
    }]
  }, {
    "text": "眉山市",
    "value": 1023,
    "children": [{
      "text": "仁寿县",
      "value": 6671
    }, {
      "text": "彭山区",
      "value": 6672
    }, {
      "text": "洪雅县",
      "value": 6673
    }, {
      "text": "丹棱县",
      "value": 6674
    }, {
      "text": "青神县",
      "value": 6675
    }, {
      "text": "东坡区",
      "value": 6676
    }]
  }, {
    "text": "广安市",
    "value": 1024,
    "children": [{
      "text": "岳池县",
      "value": 6691
    }, {
      "text": "武胜县",
      "value": 6692
    }, {
      "text": "邻水县",
      "value": 6693
    }, {
      "text": "华蓥市",
      "value": 6694
    }, {
      "text": "广安区",
      "value": 6695
    }, {
      "text": "前锋区",
      "value": 6696
    }]
  }, {
    "text": "巴中市",
    "value": 1025,
    "children": [{
      "text": "通江县",
      "value": 6871
    }, {
      "text": "南江县",
      "value": 6872
    }, {
      "text": "平昌县",
      "value": 6873
    }, {
      "text": "巴州区",
      "value": 6874
    }, {
      "text": "恩阳区",
      "value": 6875
    }]
  }, {
    "text": "资阳市",
    "value": 1026,
    "children": [{
      "text": "安岳县",
      "value": 6881
    }, {
      "text": "乐至县",
      "value": 6882
    }, {
      "text": "雁江区",
      "value": 6884
    }]
  }]
}, {
  "text": "重庆市",
  "value": 5,
  "children": [{
    "text": "重庆市",
    "value": 544,
    "children": [{
      "text": "大足区",
      "value": 6901
    }, {
      "text": "合川区",
      "value": 6902
    }, {
      "text": "万州区",
      "value": 6903
    }, {
      "text": "涪陵区",
      "value": 6904
    }, {
      "text": "渝中区",
      "value": 6905
    }, {
      "text": "九龙坡区",
      "value": 6906
    }, {
      "text": "南岸区",
      "value": 6907
    }, {
      "text": "北碚区",
      "value": 6908
    }, {
      "text": "綦江区",
      "value": 6909
    }, {
      "text": "渝北区",
      "value": 6911
    }, {
      "text": "巴南区",
      "value": 6912
    }, {
      "text": "黔江区",
      "value": 6913
    }, {
      "text": "潼南区",
      "value": 6914
    }, {
      "text": "铜梁区",
      "value": 6915
    }, {
      "text": "长寿区",
      "value": 6916
    }, {
      "text": "江津区",
      "value": 6917
    }, {
      "text": "荣昌区",
      "value": 6918
    }, {
      "text": "璧山区",
      "value": 6919
    }, {
      "text": "梁平区",
      "value": 6921
    }, {
      "text": "城口县",
      "value": 6922
    }, {
      "text": "丰都县",
      "value": 6923
    }, {
      "text": "垫江县",
      "value": 6924
    }, {
      "text": "武隆区",
      "value": 6925
    }, {
      "text": "忠  县",
      "value": 6926
    }, {
      "text": "开州区",
      "value": 6927
    }, {
      "text": "云阳县",
      "value": 6928
    }, {
      "text": "奉节县",
      "value": 6929
    }, {
      "text": "巫山县",
      "value": 6931
    }, {
      "text": "巫溪县",
      "value": 6932
    }, {
      "text": "石柱土家族自治县",
      "value": 6933
    }, {
      "text": "秀山土家族苗族自治县",
      "value": 6934
    }, {
      "text": "酉阳土家族苗族自治县",
      "value": 6935
    }, {
      "text": "彭水苗族土家族自治县",
      "value": 6936
    }, {
      "text": "沙坪坝区",
      "value": 6937
    }, {
      "text": "江北区",
      "value": 6938
    }, {
      "text": "大渡口区",
      "value": 6939
    }, {
      "text": "永川区",
      "value": 6941
    }, {
      "text": "南川区",
      "value": 6942
    }]
  }]
}, {
  "text": "贵州省",
  "value": 6,
  "children": [{
    "text": "贵阳市",
    "value": 1065,
    "children": [{
      "text": "贵安新区",
      "value": 7004
    }, {
      "text": "开阳县",
      "value": 7011
    }, {
      "text": "息烽县",
      "value": 7012
    }, {
      "text": "修文县",
      "value": 7013
    }, {
      "text": "清镇市",
      "value": 7014
    }, {
      "text": "观山湖区",
      "value": 7015
    }, {
      "text": "云岩区",
      "value": 7016
    }, {
      "text": "南明区",
      "value": 7017
    }, {
      "text": "花溪区",
      "value": 7018
    }, {
      "text": "乌当区",
      "value": 7019
    }, {
      "text": "白云区",
      "value": 7081
    }]
  }, {
    "text": "六盘水市",
    "value": 1066,
    "children": [{
      "text": "水城县",
      "value": 7021
    }, {
      "text": "盘州市",
      "value": 7022
    }, {
      "text": "钟山区",
      "value": 7023
    }, {
      "text": "六枝特区",
      "value": 7024
    }]
  }, {
    "text": "遵义市",
    "value": 1067,
    "children": [{
      "text": "播州区",
      "value": 7032
    }, {
      "text": "桐梓县",
      "value": 7033
    }, {
      "text": "绥阳县",
      "value": 7034
    }, {
      "text": "正安县",
      "value": 7035
    }, {
      "text": "道真仡佬族苗族自治县",
      "value": 7036
    }, {
      "text": "凤冈县",
      "value": 7038
    }, {
      "text": "湄潭县",
      "value": 7039
    }, {
      "text": "余庆县",
      "value": 7041
    }, {
      "text": "仁怀市",
      "value": 7042
    }, {
      "text": "赤水市",
      "value": 7043
    }, {
      "text": "习水县",
      "value": 7044
    }, {
      "text": "汇川区",
      "value": 7046
    }, {
      "text": "务川仡佬族苗族自治县",
      "value": 7037
    }, {
      "text": "红花岗区",
      "value": 7045
    }]
  }, {
    "text": "铜仁市",
    "value": 1068,
    "children": [{
      "text": "碧江区",
      "value": 7051
    }, {
      "text": "江口县",
      "value": 7052
    }, {
      "text": "玉屏侗族自治县",
      "value": 7053
    }, {
      "text": "思南县",
      "value": 7055
    }, {
      "text": "印江土家族苗族自治县",
      "value": 7056
    }, {
      "text": "德江县",
      "value": 7057
    }, {
      "text": "沿河土家族自治县",
      "value": 7058
    }, {
      "text": "万山区",
      "value": 7061
    }, {
      "text": "石阡县",
      "value": 7054
    }, {
      "text": "松桃苗族自治县",
      "value": 7059
    }]
  }, {
    "text": "黔西南布依族苗族自治州",
    "value": 1069,
    "children": [{
      "text": "兴义市",
      "value": 7071
    }, {
      "text": "普安县",
      "value": 7073
    }, {
      "text": "望谟县",
      "value": 7076
    }, {
      "text": "安龙县",
      "value": 7078
    }, {
      "text": "兴仁市",
      "value": 7072
    }, {
      "text": "晴隆县",
      "value": 7074
    }, {
      "text": "贞丰县",
      "value": 7075
    }, {
      "text": "册亨县",
      "value": 7077
    }]
  }, {
    "text": "毕节市",
    "value": 1070,
    "children": [{
      "text": "七星关区",
      "value": 7091
    }, {
      "text": "大方县",
      "value": 7092
    }, {
      "text": "黔西县",
      "value": 7093
    }, {
      "text": "织金县",
      "value": 7095
    }, {
      "text": "纳雍县",
      "value": 7096
    }, {
      "text": "威宁彝族回族苗族自治县",
      "value": 7097
    }, {
      "text": "金沙县",
      "value": 7094
    }, {
      "text": "赫章县",
      "value": 7098
    }]
  }, {
    "text": "黔东南苗族侗族自治州",
    "value": 1119,
    "children": [{
      "text": "凯里市",
      "value": 7131
    }, {
      "text": "黄平县",
      "value": 7132
    }, {
      "text": "施秉县",
      "value": 7133
    }, {
      "text": "三穗县",
      "value": 7134
    }, {
      "text": "镇远县",
      "value": 7135
    }, {
      "text": "岑巩县",
      "value": 7136
    }, {
      "text": "天柱县",
      "value": 7137
    }, {
      "text": "锦屏县",
      "value": 7138
    }, {
      "text": "剑河县",
      "value": 7139
    }, {
      "text": "台江县",
      "value": 7141
    }, {
      "text": "黎平县",
      "value": 7142
    }, {
      "text": "榕江县",
      "value": 7143
    }, {
      "text": "从江县",
      "value": 7144
    }, {
      "text": "雷山县",
      "value": 7145
    }, {
      "text": "麻江县",
      "value": 7146
    }, {
      "text": "丹寨县",
      "value": 7147
    }]
  }, {
    "text": "安顺市",
    "value": 1118,
    "children": [{
      "text": "平坝区",
      "value": 7117
    }, {
      "text": "普定县",
      "value": 7118
    }, {
      "text": "关岭布依族苗族自治县",
      "value": 7119
    }, {
      "text": "镇宁布依族苗族自治县",
      "value": 7121
    }, {
      "text": "紫云苗族布依族自治县",
      "value": 7122
    }, {
      "text": "西秀区",
      "value": 7123
    }]
  }, {
    "text": "黔南布依族苗族自治州",
    "value": 1120,
    "children": [{
      "text": "都匀市",
      "value": 7151
    }, {
      "text": "荔波县",
      "value": 7152
    }, {
      "text": "福泉市",
      "value": 7154
    }, {
      "text": "独山县",
      "value": 7156
    }, {
      "text": "罗甸县",
      "value": 7158
    }, {
      "text": "龙里县",
      "value": 7161
    }, {
      "text": "三都水族自治县",
      "value": 7163
    }, {
      "text": "贵定县",
      "value": 7153
    }, {
      "text": "瓮安县",
      "value": 7155
    }, {
      "text": "平塘县",
      "value": 7157
    }, {
      "text": "长顺县",
      "value": 7159
    }, {
      "text": "惠水县",
      "value": 7162
    }]
  }]
}, {
  "text": "甘肃省",
  "value": 7,
  "children": [{
    "text": "兰州市",
    "value": 1072,
    "children": [{
      "text": "永登县",
      "value": 8211
    }, {
      "text": "榆中县",
      "value": 8213
    }, {
      "text": "七里河区",
      "value": 8214
    }, {
      "text": "城关区",
      "value": 8215
    }, {
      "text": "西固区",
      "value": 8216
    }, {
      "text": "红古区",
      "value": 8218
    }, {
      "text": "皋兰县",
      "value": 8212
    }, {
      "text": "安宁区",
      "value": 8217
    }]
  }, {
    "text": "嘉峪关市",
    "value": 1073,
    "children": [{
      "text": "嘉峪关",
      "value": 8220
    }]
  }, {
    "text": "金昌市",
    "value": 1074,
    "children": [{
      "text": "永昌县",
      "value": 8231
    }, {
      "text": "金川区",
      "value": 8232
    }]
  }, {
    "text": "白银市",
    "value": 1075,
    "children": [{
      "text": "会宁县",
      "value": 8242
    }, {
      "text": "景泰县",
      "value": 8243
    }, {
      "text": "白银区",
      "value": 8244
    }, {
      "text": "平川区",
      "value": 8245
    }, {
      "text": "靖远县",
      "value": 8241
    }]
  }, {
    "text": "天水市",
    "value": 1076,
    "children": [{
      "text": "秦安县",
      "value": 8252
    }, {
      "text": "甘谷县",
      "value": 8253
    }, {
      "text": "武山县",
      "value": 8254
    }, {
      "text": "秦州区",
      "value": 8256
    }, {
      "text": "麦积区",
      "value": 8257
    }, {
      "text": "清水县",
      "value": 8251
    }, {
      "text": "张家川回族自治县",
      "value": 8255
    }]
  }, {
    "text": "酒泉市",
    "value": 1077,
    "children": [{
      "text": "玉门市",
      "value": 8261
    }, {
      "text": "肃州区",
      "value": 8262
    }, {
      "text": "敦煌市",
      "value": 8263
    }, {
      "text": "肃北蒙古族自治县",
      "value": 8265
    }, {
      "text": "阿克塞哈萨克族自治县",
      "value": 8266
    }, {
      "text": "瓜州县",
      "value": 8267
    }, {
      "text": "金塔县",
      "value": 8264
    }]
  }, {
    "text": "张掖市",
    "value": 1078,
    "children": [{
      "text": "甘州区",
      "value": 8271
    }, {
      "text": "民乐县",
      "value": 8273
    }, {
      "text": "临泽县",
      "value": 8274
    }, {
      "text": "高台县",
      "value": 8275
    }, {
      "text": "山丹县",
      "value": 8276
    }, {
      "text": "肃南裕固族自治县",
      "value": 8272
    }]
  }, {
    "text": "武威市",
    "value": 1079,
    "children": [{
      "text": "凉州区",
      "value": 8281
    }, {
      "text": "古浪县",
      "value": 8283
    }, {
      "text": "天祝藏族自治县",
      "value": 8284
    }, {
      "text": "民勤县",
      "value": 8282
    }]
  }, {
    "text": "定西市",
    "value": 1080,
    "children": [{
      "text": "安定区",
      "value": 8291
    }, {
      "text": "通渭县",
      "value": 8292
    }, {
      "text": "渭源县",
      "value": 8294
    }, {
      "text": "临洮县",
      "value": 8295
    }, {
      "text": "漳  县",
      "value": 8296
    }, {
      "text": "陇西县",
      "value": 8293
    }, {
      "text": "岷  县",
      "value": 8297
    }]
  }, {
    "text": "陇南市",
    "value": 1081,
    "children": [{
      "text": "武都区",
      "value": 8311
    }, {
      "text": "宕昌县",
      "value": 8312
    }, {
      "text": "成  县",
      "value": 8313
    }, {
      "text": "康  县",
      "value": 8314
    }, {
      "text": "西和县",
      "value": 8316
    }, {
      "text": "礼  县",
      "value": 8317
    }, {
      "text": "两当县",
      "value": 8318
    }, {
      "text": "文  县",
      "value": 8315
    }, {
      "text": "徽  县",
      "value": 8319
    }]
  }, {
    "text": "平凉市",
    "value": 1082,
    "children": [{
      "text": "崆峒区",
      "value": 8331
    }, {
      "text": "泾川县",
      "value": 8332
    }, {
      "text": "灵台县",
      "value": 8333
    }, {
      "text": "崇信县",
      "value": 8334
    }, {
      "text": "庄浪县",
      "value": 8336
    }, {
      "text": "静宁县",
      "value": 8337
    }, {
      "text": "华亭市",
      "value": 8335
    }]
  }, {
    "text": "庆阳市",
    "value": 1083,
    "children": [{
      "text": "庆城县",
      "value": 8342
    }, {
      "text": "华池县",
      "value": 8344
    }, {
      "text": "合水县",
      "value": 8345
    }, {
      "text": "正宁县",
      "value": 8346
    }, {
      "text": "宁  县",
      "value": 8347
    }, {
      "text": "西峰区",
      "value": 8349
    }, {
      "text": "环  县",
      "value": 8343
    }, {
      "text": "镇原县",
      "value": 8348
    }]
  }, {
    "text": "临夏回族自治州",
    "value": 1084,
    "children": [{
      "text": "临夏市",
      "value": 8361
    }, {
      "text": "康乐县",
      "value": 8363
    }, {
      "text": "广河县",
      "value": 8365
    }, {
      "text": "和政县",
      "value": 8366
    }, {
      "text": "积石山保安族东乡族撒拉族自治县",
      "value": 8368
    }, {
      "text": "临夏县",
      "value": 8362
    }, {
      "text": "永靖县",
      "value": 8364
    }, {
      "text": "东乡族自治县",
      "value": 8367
    }]
  }, {
    "text": "甘南藏族自治州",
    "value": 1085,
    "children": [{
      "text": "卓尼县",
      "value": 8382
    }, {
      "text": "舟曲县",
      "value": 8383
    }, {
      "text": "玛曲县",
      "value": 8385
    }, {
      "text": "夏河县",
      "value": 8387
    }, {
      "text": "合作市",
      "value": 8388
    }, {
      "text": "临潭县",
      "value": 8381
    }, {
      "text": "迭部县",
      "value": 8384
    }, {
      "text": "碌曲县",
      "value": 8386
    }]
  }]
}, {
  "text": "青海省",
  "value": 8,
  "children": [{
    "text": "西宁市",
    "value": 1086,
    "children": [{
      "text": "大通回族土族自治县",
      "value": 8511
    }, {
      "text": "湟源县",
      "value": 8513
    }, {
      "text": "城东区",
      "value": 8514
    }, {
      "text": "城中区",
      "value": 8515
    }, {
      "text": "城西区",
      "value": 8516
    }, {
      "text": "城北区",
      "value": 8517
    }, {
      "text": "湟中县",
      "value": 8512
    }]
  }, {
    "text": "海东市",
    "value": 1087,
    "children": [{
      "text": "平安区",
      "value": 8521
    }, {
      "text": "民和回族土族自治县",
      "value": 8522
    }, {
      "text": "乐都区",
      "value": 8523
    }, {
      "text": "互助土族自治县",
      "value": 8526
    }, {
      "text": "化隆回族自治县",
      "value": 8527
    }, {
      "text": "循化撒拉族自治县",
      "value": 8528
    }]
  }, {
    "text": "海北藏族自治州",
    "value": 1088,
    "children": [{
      "text": "门源回族自治县",
      "value": 8541
    }, {
      "text": "祁连县",
      "value": 8542
    }, {
      "text": "海晏县",
      "value": 8543
    }, {
      "text": "刚察县",
      "value": 8544
    }]
  }, {
    "text": "黄南藏族自治州",
    "value": 1089,
    "children": [{
      "text": "同仁县",
      "value": 8551
    }, {
      "text": "尖扎县",
      "value": 8552
    }, {
      "text": "泽库县",
      "value": 8553
    }, {
      "text": "河南蒙古族自治县",
      "value": 8554
    }]
  }, {
    "text": "海南藏族自治州",
    "value": 1090,
    "children": [{
      "text": "共和县",
      "value": 8561
    }, {
      "text": "同德县",
      "value": 8562
    }, {
      "text": "贵德县",
      "value": 8563
    }, {
      "text": "兴海县",
      "value": 8564
    }, {
      "text": "贵南县",
      "value": 8565
    }]
  }, {
    "text": "果洛藏族自治州",
    "value": 1091,
    "children": [{
      "text": "玛沁县",
      "value": 8571
    }, {
      "text": "班玛县",
      "value": 8572
    }, {
      "text": "甘德县",
      "value": 8573
    }, {
      "text": "达日县",
      "value": 8574
    }, {
      "text": "久治县",
      "value": 8575
    }, {
      "text": "玛多县",
      "value": 8576
    }]
  }, {
    "text": "玉树藏族自治州",
    "value": 1092,
    "children": [{
      "text": "玉树县",
      "value": 8581
    }, {
      "text": "杂多县",
      "value": 8582
    }, {
      "text": "称多县",
      "value": 8583
    }, {
      "text": "治多县",
      "value": 8584
    }, {
      "text": "囊谦县",
      "value": 8585
    }, {
      "text": "曲麻莱县",
      "value": 8586
    }]
  }, {
    "text": "海西蒙古族藏族自治州",
    "value": 1093,
    "children": [{
      "text": "格尔木市",
      "value": 8591
    }, {
      "text": "德令哈市",
      "value": 8592
    }, {
      "text": "乌兰县",
      "value": 8593
    }, {
      "text": "都兰县",
      "value": 8594
    }, {
      "text": "天峻县",
      "value": 8595
    }, {
      "text": "茫崖市",
      "value": 8596
    }]
  }]
}, {
  "text": "宁夏回族自治区",
  "value": 9,
  "children": [{
    "text": "银川市",
    "value": 1094,
    "children": [{
      "text": "永宁县",
      "value": 8711
    }, {
      "text": "贺兰县",
      "value": 8712
    }, {
      "text": "灵武市",
      "value": 8713
    }, {
      "text": "兴庆区",
      "value": 8714
    }, {
      "text": "西夏区",
      "value": 8715
    }, {
      "text": "金凤区",
      "value": 8716
    }]
  }, {
    "text": "石嘴山市",
    "value": 1095,
    "children": [{
      "text": "平罗县",
      "value": 8721
    }, {
      "text": "大武口区",
      "value": 8722
    }, {
      "text": "惠农区",
      "value": 8723
    }]
  }, {
    "text": "吴忠市",
    "value": 1096,
    "children": [{
      "text": "利通区",
      "value": 8731
    }, {
      "text": "青铜峡市",
      "value": 8732
    }, {
      "text": "红寺堡区",
      "value": 8733
    }, {
      "text": "盐池县",
      "value": 8736
    }, {
      "text": "同心县",
      "value": 8737
    }]
  }, {
    "text": "固原市",
    "value": 1097,
    "children": [{
      "text": "原州区",
      "value": 8741
    }, {
      "text": "西吉县",
      "value": 8743
    }, {
      "text": "隆德县",
      "value": 8744
    }, {
      "text": "泾源县",
      "value": 8745
    }, {
      "text": "彭阳县",
      "value": 8746
    }]
  }, {
    "text": "中卫市",
    "value": 1098,
    "children": [{
      "text": "中宁县",
      "value": 8751
    }, {
      "text": "海原县",
      "value": 8752
    }, {
      "text": "沙坡头区",
      "value": 8753
    }]
  }]
}, {
  "text": "新疆维吾尔族自治区",
  "value": 10,
  "children": [{
    "text": "乌鲁木齐市",
    "value": 1099,
    "children": [{
      "text": "乌鲁木齐县",
      "value": 8811
    }, {
      "text": "米东区",
      "value": 8812
    }, {
      "text": "天山区",
      "value": 8813
    }, {
      "text": "沙依巴克区",
      "value": 8814
    }, {
      "text": "新市区",
      "value": 8815
    }, {
      "text": "水磨沟区",
      "value": 8816
    }, {
      "text": "头屯河区",
      "value": 8817
    }, {
      "text": "达坂城区",
      "value": 8818
    }]
  }, {
    "text": "克拉玛依市",
    "value": 1100,
    "children": [{
      "text": "独山子区",
      "value": 8821
    }, {
      "text": "克拉玛依区",
      "value": 8822
    }, {
      "text": "白碱滩区",
      "value": 8823
    }, {
      "text": "乌尔禾区",
      "value": 8824
    }]
  }, {
    "text": "吐鲁番市",
    "value": 1101,
    "children": [{
      "text": "高昌区",
      "value": 8831
    }, {
      "text": "鄯善县",
      "value": 8832
    }, {
      "text": "托克逊县",
      "value": 8833
    }]
  }, {
    "text": "哈密市",
    "value": 1102,
    "children": [{
      "text": "巴里坤哈萨克自治县",
      "value": 8842
    }, {
      "text": "伊吾县",
      "value": 8843
    }, {
      "text": "伊州区",
      "value": 8841
    }]
  }, {
    "text": "博尔塔拉蒙古自治州",
    "value": 1104,
    "children": [{
      "text": "博乐市",
      "value": 8871
    }, {
      "text": "温泉县",
      "value": 8873
    }, {
      "text": "阿拉山口市",
      "value": 8874
    }, {
      "text": "精河县",
      "value": 8872
    }]
  }, {
    "text": "巴音郭楞蒙古自治州",
    "value": 1105,
    "children": [{
      "text": "尉犁县",
      "value": 8883
    }, {
      "text": "若羌县",
      "value": 8884
    }, {
      "text": "焉耆回族自治县",
      "value": 8886
    }, {
      "text": "和静县",
      "value": 8887
    }, {
      "text": "博湖县",
      "value": 8889
    }, {
      "text": "库尔勒市",
      "value": 8881
    }, {
      "text": "轮台县",
      "value": 8882
    }, {
      "text": "且末县",
      "value": 8885
    }, {
      "text": "和硕县",
      "value": 8888
    }]
  }, {
    "text": "克孜勒苏柯尔克孜自治州",
    "value": 1112,
    "children": [{
      "text": "阿克陶县",
      "value": 8932
    }, {
      "text": "阿合奇县",
      "value": 8933
    }, {
      "text": "阿图什市",
      "value": 8931
    }, {
      "text": "乌恰县",
      "value": 8934
    }]
  }, {
    "text": "喀什地区",
    "value": 1113,
    "children": [{
      "text": "喀什市",
      "value": 8941
    }, {
      "text": "疏附县",
      "value": 8942
    }, {
      "text": "疏勒县",
      "value": 8943
    }, {
      "text": "英吉沙县",
      "value": 8944
    }, {
      "text": "泽普县",
      "value": 8945
    }, {
      "text": "叶城县",
      "value": 8947
    }, {
      "text": "麦盖提县",
      "value": 8948
    }, {
      "text": "岳普湖县",
      "value": 8949
    }, {
      "text": "伽师县",
      "value": 8951
    }, {
      "text": "塔什库尔干塔吉克自治县",
      "value": 8953
    }, {
      "text": "莎车县",
      "value": 8946
    }, {
      "text": "巴楚县",
      "value": 8952
    }]
  }, {
    "text": "伊犁哈萨克自治州",
    "value": 1115,
    "children": [{
      "text": "奎屯市",
      "value": 8981
    }, {
      "text": "霍尔果斯市",
      "value": 8983
    }, {
      "text": "伊宁市",
      "value": 8991
    }, {
      "text": "伊宁县",
      "value": 8992
    }, {
      "text": "察布查尔锡伯自治县",
      "value": 8993
    }, {
      "text": "霍城县",
      "value": 8994
    }, {
      "text": "巩留县",
      "value": 8995
    }, {
      "text": "新源县",
      "value": 8996
    }, {
      "text": "昭苏县",
      "value": 8997
    }, {
      "text": "特克斯县",
      "value": 8998
    }, {
      "text": "尼勒克县",
      "value": 8999
    }]
  }, {
    "text": "塔城地区",
    "value": 1116,
    "children": [{
      "text": "塔城市",
      "value": 9011
    }, {
      "text": "额敏县",
      "value": 9012
    }, {
      "text": "乌苏市",
      "value": 9013
    }, {
      "text": "沙湾县",
      "value": 9014
    }, {
      "text": "托里县",
      "value": 9015
    }, {
      "text": "裕民县",
      "value": 9016
    }, {
      "text": "和布克赛尔蒙古自治县",
      "value": 9017
    }]
  }, {
    "text": "阿勒泰地区",
    "value": 1117,
    "children": [{
      "text": "阿勒泰市",
      "value": 9021
    }, {
      "text": "布尔津县",
      "value": 9022
    }, {
      "text": "富蕴县",
      "value": 9023
    }, {
      "text": "福海县",
      "value": 9024
    }, {
      "text": "哈巴河县",
      "value": 9025
    }, {
      "text": "青河县",
      "value": 9026
    }, {
      "text": "吉木乃县",
      "value": 9027
    }, {
      "text": "石河子市（自治区直辖）",
      "value": 9028
    }, {
      "text": "阿拉尔市（自治区直辖）",
      "value": 9041
    }, {
      "text": "图木舒克市（自治区直辖）",
      "value": 9042
    }, {
      "text": "五家渠市（自治区直辖）",
      "value": 9043
    }, {
      "text": "北屯市（自治区直辖）",
      "value": 9044
    }, {
      "text": "双河市（自治区直辖）",
      "value": 9045
    }, {
      "text": "可克达拉市(自治区直辖)",
      "value": 9046
    }, {
      "text": "铁门关市（自治区直辖）",
      "value": 8890
    }, {
      "text": "昆玉市(自治区直辖)",
      "value": 9047
    }]
  }, {
    "text": "昌吉回族自治州",
    "value": 1103,
    "children": [{
      "text": "昌吉市",
      "value": 8851
    }, {
      "text": "玛纳斯县",
      "value": 8854
    }, {
      "text": "奇台县",
      "value": 8855
    }, {
      "text": "阜康市",
      "value": 8856
    }, {
      "text": "木垒哈萨克自治县",
      "value": 8858
    }, {
      "text": "呼图壁县",
      "value": 8853
    }, {
      "text": "吉木萨尔县",
      "value": 8857
    }]
  }, {
    "text": "阿克苏地区",
    "value": 1111,
    "children": [{
      "text": "阿克苏市",
      "value": 8911
    }, {
      "text": "温宿县",
      "value": 8912
    }, {
      "text": "沙雅县",
      "value": 8914
    }, {
      "text": "新和县",
      "value": 8915
    }, {
      "text": "拜城县",
      "value": 8916
    }, {
      "text": "阿瓦提县",
      "value": 8918
    }, {
      "text": "柯坪县",
      "value": 8919
    }, {
      "text": "库车县",
      "value": 8913
    }, {
      "text": "乌什县",
      "value": 8917
    }]
  }, {
    "text": "和田地区",
    "value": 1114,
    "children": [{
      "text": "和田市",
      "value": 8961
    }, {
      "text": "和田县",
      "value": 8962
    }, {
      "text": "墨玉县",
      "value": 8963
    }, {
      "text": "洛浦县",
      "value": 8965
    }, {
      "text": "策勒县",
      "value": 8966
    }, {
      "text": "于田县",
      "value": 8967
    }, {
      "text": "民丰县",
      "value": 8968
    }, {
      "text": "皮山县",
      "value": 8964
    }]
  }]
}, {
  "text": "云南省",
  "value": 11,
  "children": [{
    "text": "昆明市",
    "value": 1121,
    "children": [{
      "text": "东川区",
      "value": 7311
    }, {
      "text": "晋宁区",
      "value": 7312
    }, {
      "text": "富民县",
      "value": 7314
    }, {
      "text": "宜良县",
      "value": 7315
    }, {
      "text": "石林彝族自治县",
      "value": 7316
    }, {
      "text": "禄劝彝族苗族自治县",
      "value": 7318
    }, {
      "text": "寻甸回族彝族自治县",
      "value": 7319
    }, {
      "text": "呈贡区",
      "value": 7321
    }, {
      "text": "五华区",
      "value": 7322
    }, {
      "text": "官渡区",
      "value": 7324
    }, {
      "text": "西山区",
      "value": 7325
    }, {
      "text": "安宁市",
      "value": 7313
    }, {
      "text": "嵩明县",
      "value": 7317
    }, {
      "text": "盘龙区",
      "value": 7323
    }]
  }, {
    "text": "昭通市",
    "value": 1122,
    "children": [{
      "text": "鲁甸县",
      "value": 7342
    }, {
      "text": "盐津县",
      "value": 7344
    }, {
      "text": "大关县",
      "value": 7345
    }, {
      "text": "永善县",
      "value": 7346
    }, {
      "text": "绥江县",
      "value": 7347
    }, {
      "text": "彝良县",
      "value": 7349
    }, {
      "text": "威信县",
      "value": 7351
    }, {
      "text": "水富市",
      "value": 7352
    }, {
      "text": "巧家县",
      "value": 7343
    }, {
      "text": "镇雄县",
      "value": 7348
    }, {
      "text": "昭阳区",
      "value": 7353
    }]
  }, {
    "text": "曲靖市",
    "value": 1123,
    "children": [{
      "text": "马龙区",
      "value": 7362
    }, {
      "text": "宣威市",
      "value": 7363
    }, {
      "text": "富源县",
      "value": 7364
    }, {
      "text": "罗平县",
      "value": 7365
    }, {
      "text": "陆良县",
      "value": 7367
    }, {
      "text": "会泽县",
      "value": 7369
    }, {
      "text": "沾益区",
      "value": 7371
    }, {
      "text": "师宗县",
      "value": 7366
    }, {
      "text": "麒麟区",
      "value": 7372
    }]
  }, {
    "text": "楚雄彝族自治州",
    "value": 1124,
    "children": [{
      "text": "楚雄市",
      "value": 7381
    }, {
      "text": "牟定县",
      "value": 7383
    }, {
      "text": "南华县",
      "value": 7384
    }, {
      "text": "大姚县",
      "value": 7386
    }, {
      "text": "元谋县",
      "value": 7388
    }, {
      "text": "武定县",
      "value": 7389
    }, {
      "text": "双柏县",
      "value": 7382
    }, {
      "text": "姚安县",
      "value": 7385
    }, {
      "text": "永仁县",
      "value": 7387
    }, {
      "text": "禄丰县",
      "value": 7391
    }]
  }, {
    "text": "红河哈尼族彝族自治州",
    "value": 1126,
    "children": [{
      "text": "个旧市",
      "value": 7431
    }, {
      "text": "开远市",
      "value": 7432
    }, {
      "text": "屏边苗族自治县",
      "value": 7434
    }, {
      "text": "石屏县",
      "value": 7436
    }, {
      "text": "泸西县",
      "value": 7438
    }, {
      "text": "红河县",
      "value": 7441
    }, {
      "text": "绿春县",
      "value": 7443
    }, {
      "text": "河口瑶族自治县",
      "value": 7444
    }, {
      "text": "蒙自市",
      "value": 7433
    }, {
      "text": "建水县",
      "value": 7435
    }, {
      "text": "弥勒市",
      "value": 7437
    }, {
      "text": "元阳县",
      "value": 7439
    }, {
      "text": "金平苗族瑶族傣族自治县",
      "value": 7442
    }]
  }, {
    "text": "普洱市",
    "value": 1128,
    "children": [{
      "text": "思茅区",
      "value": 7471
    }, {
      "text": "宁洱哈尼族彝族自治县",
      "value": 7472
    }, {
      "text": "景东彝族自治县",
      "value": 7474
    }, {
      "text": "景谷傣族彝族自治县",
      "value": 7475
    }, {
      "text": "镇沅彝族哈尼族拉祜族自治县",
      "value": 7476
    }, {
      "text": "江城哈尼族彝族自治县",
      "value": 7477
    }, {
      "text": "孟连傣族拉祜族佤族自治县",
      "value": 7478
    }, {
      "text": "西盟佤族自治县",
      "value": 7481
    }, {
      "text": "墨江哈尼族自治县",
      "value": 7473
    }, {
      "text": "澜沧拉祜族自治县",
      "value": 7479
    }]
  }, {
    "text": "西双版纳傣族自治州",
    "value": 1129,
    "children": [{
      "text": "景洪市",
      "value": 7491
    }, {
      "text": "勐腊县",
      "value": 7493
    }, {
      "text": "勐海县",
      "value": 7492
    }]
  }, {
    "text": "保山市",
    "value": 1131,
    "children": [{
      "text": "隆阳区",
      "value": 7531
    }, {
      "text": "腾冲市",
      "value": 7533
    }, {
      "text": "龙陵县",
      "value": 7534
    }, {
      "text": "昌宁县",
      "value": 7535
    }, {
      "text": "施甸县",
      "value": 7532
    }]
  }, {
    "text": "德宏傣族景颇族自治州",
    "value": 1132,
    "children": [{
      "text": "梁河县",
      "value": 7543
    }, {
      "text": "陇川县",
      "value": 7545
    }, {
      "text": "芒  市",
      "value": 7542
    }, {
      "text": "盈江县",
      "value": 7544
    }, {
      "text": "瑞丽市",
      "value": 7546
    }]
  }, {
    "text": "丽江市",
    "value": 1133,
    "children": [{
      "text": "古城区",
      "value": 7551
    }, {
      "text": "永胜县",
      "value": 7552
    }, {
      "text": "华坪县",
      "value": 7553
    }, {
      "text": "宁蒗彝族自治县",
      "value": 7554
    }, {
      "text": "玉龙纳西族自治县",
      "value": 7555
    }]
  }, {
    "text": "迪庆藏族自治州",
    "value": 1135,
    "children": [{
      "text": "香格里拉市",
      "value": 7571
    }, {
      "text": "维西傈僳族自治县",
      "value": 7573
    }, {
      "text": "德钦县",
      "value": 7572
    }]
  }, {
    "text": "临沧市",
    "value": 1136,
    "children": [{
      "text": "临翔区",
      "value": 7581
    }, {
      "text": "凤庆县",
      "value": 7582
    }, {
      "text": "云　县",
      "value": 7583
    }, {
      "text": "永德县",
      "value": 7584
    }, {
      "text": "镇康县",
      "value": 7585
    }, {
      "text": "双江拉祜族佤族布朗族傣族自治县",
      "value": 7586
    }, {
      "text": "耿马傣族佤族自治县",
      "value": 7587
    }, {
      "text": "沧源佤族自治县",
      "value": 7588
    }]
  }, {
    "text": "玉溪市",
    "value": 1125,
    "children": [{
      "text": "红塔区",
      "value": 7411
    }, {
      "text": "江川区",
      "value": 7412
    }, {
      "text": "澄江县",
      "value": 7413
    }, {
      "text": "通海县",
      "value": 7414
    }, {
      "text": "易门县",
      "value": 7416
    }, {
      "text": "峨山彝族自治县",
      "value": 7417
    }, {
      "text": "新平彝族傣族自治县",
      "value": 7418
    }, {
      "text": "华宁县",
      "value": 7415
    }, {
      "text": "元江哈尼族彝族傣族自治县",
      "value": 7419
    }]
  }, {
    "text": "文山壮族苗族自治州",
    "value": 1127,
    "children": [{
      "text": "砚山县",
      "value": 7452
    }, {
      "text": "麻栗坡县",
      "value": 7454
    }, {
      "text": "丘北县",
      "value": 7456
    }, {
      "text": "富宁县",
      "value": 7458
    }, {
      "text": "文山市",
      "value": 7451
    }, {
      "text": "西畴县",
      "value": 7453
    }, {
      "text": "马关县",
      "value": 7455
    }, {
      "text": "广南县",
      "value": 7457
    }]
  }, {
    "text": "大理白族自治州",
    "value": 1130,
    "children": [{
      "text": "大理市",
      "value": 7511
    }, {
      "text": "祥云县",
      "value": 7513
    }, {
      "text": "宾川县",
      "value": 7514
    }, {
      "text": "南涧彝族自治县",
      "value": 7516
    }, {
      "text": "永平县",
      "value": 7518
    }, {
      "text": "云龙县",
      "value": 7519
    }, {
      "text": "洱源县",
      "value": 7521
    }, {
      "text": "鹤庆县",
      "value": 7523
    }, {
      "text": "漾濞彝族自治县",
      "value": 7512
    }, {
      "text": "弥渡县",
      "value": 7515
    }, {
      "text": "巍山彝族回族自治县",
      "value": 7517
    }, {
      "text": "剑川县",
      "value": 7522
    }]
  }, {
    "text": "怒江傈僳族自治州",
    "value": 1134,
    "children": [{
      "text": "泸水市",
      "value": 7561
    }, {
      "text": "福贡县",
      "value": 7562
    }, {
      "text": "兰坪白族普米族自治县",
      "value": 7564
    }, {
      "text": "贡山独龙族怒族自治县",
      "value": 7563
    }]
  }]
}, {
  "text": "西藏自治区",
  "value": 12,
  "children": [{
    "text": "日喀则市",
    "value": 1140,
    "children": [{
      "text": "桑珠孜区",
      "value": 7761
    }, {
      "text": "南木林县",
      "value": 7762
    }, {
      "text": "江孜县",
      "value": 7763
    }, {
      "text": "定日县",
      "value": 7764
    }, {
      "text": "萨迦县",
      "value": 7765
    }, {
      "text": "拉孜县",
      "value": 7766
    }, {
      "text": "昂仁县",
      "value": 7767
    }, {
      "text": "谢通门县",
      "value": 7768
    }, {
      "text": "白朗县",
      "value": 7769
    }, {
      "text": "仁布县",
      "value": 7771
    }, {
      "text": "康马县",
      "value": 7772
    }, {
      "text": "定结县",
      "value": 7773
    }, {
      "text": "仲巴县",
      "value": 7774
    }, {
      "text": "亚东县",
      "value": 7775
    }, {
      "text": "吉隆县",
      "value": 7776
    }, {
      "text": "聂拉木县",
      "value": 7777
    }, {
      "text": "萨嘎县",
      "value": 7778
    }, {
      "text": "岗巴县",
      "value": 7779
    }]
  }, {
    "text": "那曲市",
    "value": 1141,
    "children": [{
      "text": "色尼区",
      "value": 7791
    }, {
      "text": "嘉黎县",
      "value": 7792
    }, {
      "text": "比如县",
      "value": 7793
    }, {
      "text": "聂荣县",
      "value": 7794
    }, {
      "text": "安多县",
      "value": 7795
    }, {
      "text": "申扎县",
      "value": 7796
    }, {
      "text": "索　县",
      "value": 7797
    }, {
      "text": "班戈县",
      "value": 7798
    }, {
      "text": "巴青县",
      "value": 7799
    }, {
      "text": "尼玛县",
      "value": 7801
    }, {
      "text": "双湖县",
      "value": 7802
    }]
  }, {
    "text": "阿里地区",
    "value": 1142,
    "children": [{
      "text": "普兰县",
      "value": 7811
    }, {
      "text": "札达县",
      "value": 7812
    }, {
      "text": "噶尔县",
      "value": 7813
    }, {
      "text": "日土县",
      "value": 7814
    }, {
      "text": "革吉县",
      "value": 7815
    }, {
      "text": "改则县",
      "value": 7816
    }, {
      "text": "措勤县",
      "value": 7817
    }]
  }, {
    "text": "林芝市",
    "value": 1143,
    "children": [{
      "text": "巴宜区",
      "value": 7831
    }, {
      "text": "工布江达县",
      "value": 7832
    }, {
      "text": "米林县",
      "value": 7833
    }, {
      "text": "墨脱县",
      "value": 7834
    }, {
      "text": "波密县",
      "value": 7835
    }, {
      "text": "察隅县",
      "value": 7836
    }, {
      "text": "朗  县",
      "value": 7837
    }]
  }, {
    "text": "拉萨市",
    "value": 1137,
    "children": [{
      "text": "林周县",
      "value": 7711
    }, {
      "text": "当雄县",
      "value": 7712
    }, {
      "text": "尼木县",
      "value": 7713
    }, {
      "text": "曲水县",
      "value": 7714
    }, {
      "text": "堆龙德庆区",
      "value": 7715
    }, {
      "text": "达孜区",
      "value": 7716
    }, {
      "text": "墨竹工卡县",
      "value": 7717
    }, {
      "text": "城关区",
      "value": 7718
    }]
  }, {
    "text": "山南市",
    "value": 1139,
    "children": [{
      "text": "乃东区",
      "value": 7741
    }, {
      "text": "扎囊县",
      "value": 7742
    }, {
      "text": "贡嘎县",
      "value": 7743
    }, {
      "text": "桑日县",
      "value": 7744
    }, {
      "text": "琼结县",
      "value": 7745
    }, {
      "text": "曲松县",
      "value": 7746
    }, {
      "text": "措美县",
      "value": 7747
    }, {
      "text": "洛扎县",
      "value": 7748
    }, {
      "text": "加查县",
      "value": 7749
    }, {
      "text": "隆子县",
      "value": 7751
    }, {
      "text": "错那县",
      "value": 7752
    }, {
      "text": "浪卡子县",
      "value": 7753
    }]
  }, {
    "text": "昌都市",
    "value": 1138,
    "children": [{
      "text": "卡若区",
      "value": 7721
    }, {
      "text": "江达县",
      "value": 7722
    }, {
      "text": "贡觉县",
      "value": 7723
    }, {
      "text": "类乌齐县",
      "value": 7724
    }, {
      "text": "丁青县",
      "value": 7725
    }, {
      "text": "察雅县",
      "value": 7726
    }, {
      "text": "八宿县",
      "value": 7727
    }, {
      "text": "左贡县",
      "value": 7728
    }, {
      "text": "芒康县",
      "value": 7729
    }, {
      "text": "洛隆县",
      "value": 7731
    }, {
      "text": "边坝县",
      "value": 7732
    }]
  }]
}, {
  "text": "陕西省",
  "value": 13,
  "children": [{
    "text": "西安市",
    "value": 1144,
    "children": [{
      "text": "西咸新区",
      "value": 7904
    }, {
      "text": "新城区",
      "value": 7911
    }, {
      "text": "蓝田县",
      "value": 7912
    }, {
      "text": "碑林区",
      "value": 7913
    }, {
      "text": "周至县",
      "value": 7914
    }, {
      "text": "鄠邑区",
      "value": 7915
    }, {
      "text": "高陵区",
      "value": 7916
    }, {
      "text": "临潼区",
      "value": 7917
    }, {
      "text": "莲湖区",
      "value": 7918
    }, {
      "text": "灞桥区",
      "value": 7919
    }, {
      "text": "未央区",
      "value": 8081
    }, {
      "text": "雁塔区",
      "value": 8082
    }, {
      "text": "阎良区",
      "value": 8083
    }, {
      "text": "长安区",
      "value": 8084
    }]
  }, {
    "text": "铜川市",
    "value": 1145,
    "children": [{
      "text": "王益区",
      "value": 7921
    }, {
      "text": "宜君县",
      "value": 7922
    }, {
      "text": "印台区",
      "value": 7923
    }, {
      "text": "耀州区",
      "value": 7924
    }]
  }, {
    "text": "宝鸡市",
    "value": 1146,
    "children": [{
      "text": "渭滨区",
      "value": 7931
    }, {
      "text": "凤翔县",
      "value": 7932
    }, {
      "text": "岐山县",
      "value": 7933
    }, {
      "text": "扶风县",
      "value": 7934
    }, {
      "text": "眉　县",
      "value": 7935
    }, {
      "text": "陇　县",
      "value": 7936
    }, {
      "text": "千阳县",
      "value": 7937
    }, {
      "text": "麟游县",
      "value": 7938
    }, {
      "text": "凤　县",
      "value": 7939
    }, {
      "text": "太白县",
      "value": 7941
    }, {
      "text": "金台区",
      "value": 7942
    }, {
      "text": "陈仓区",
      "value": 7943
    }]
  }, {
    "text": "咸阳市",
    "value": 1147,
    "children": [{
      "text": "三原县",
      "value": 7952
    }, {
      "text": "泾阳县",
      "value": 7953
    }, {
      "text": "乾　县",
      "value": 7954
    }, {
      "text": "礼泉县",
      "value": 7955
    }, {
      "text": "彬州市",
      "value": 7957
    }, {
      "text": "长武县",
      "value": 7958
    }, {
      "text": "旬邑县",
      "value": 7959
    }, {
      "text": "武功县",
      "value": 7962
    }, {
      "text": "秦都区",
      "value": 7963
    }, {
      "text": "杨陵区",
      "value": 7964
    }, {
      "text": "渭城区",
      "value": 7965
    }, {
      "text": "兴平市",
      "value": 7951
    }, {
      "text": "永寿县",
      "value": 7956
    }, {
      "text": "淳化县",
      "value": 7961
    }]
  }, {
    "text": "榆林市",
    "value": 1071,
    "children": [{
      "text": "神木市",
      "value": 8062
    }, {
      "text": "府谷县",
      "value": 8063
    }, {
      "text": "横山区",
      "value": 8064
    }, {
      "text": "定边县",
      "value": 8066
    }, {
      "text": "绥德县",
      "value": 8067
    }, {
      "text": "米脂县",
      "value": 8068
    }, {
      "text": "佳县",
      "value": 8069
    }, {
      "text": "清涧县",
      "value": 8072
    }, {
      "text": "子洲县",
      "value": 8073
    }, {
      "text": "榆阳区",
      "value": 8061
    }, {
      "text": "靖边县",
      "value": 8065
    }, {
      "text": "吴堡县",
      "value": 8071
    }]
  }, {
    "text": "渭南市",
    "value": 1106,
    "children": [{
      "text": "韩城市",
      "value": 7972
    }, {
      "text": "华州区",
      "value": 7973
    }, {
      "text": "华阴市",
      "value": 7974
    }, {
      "text": "大荔县",
      "value": 7976
    }, {
      "text": "蒲城县",
      "value": 7977
    }, {
      "text": "澄城县",
      "value": 7978
    }, {
      "text": "白水县",
      "value": 7979
    }, {
      "text": "富平县",
      "value": 7982
    }, {
      "text": "临渭区",
      "value": 7971
    }, {
      "text": "潼关县",
      "value": 7975
    }, {
      "text": "合阳县",
      "value": 7981
    }]
  }, {
    "text": "安康市",
    "value": 1108,
    "children": [{
      "text": "汉阴县",
      "value": 8012
    }, {
      "text": "石泉县",
      "value": 8013
    }, {
      "text": "宁陕县",
      "value": 8014
    }, {
      "text": "紫阳县",
      "value": 8015
    }, {
      "text": "平利县",
      "value": 8017
    }, {
      "text": "镇坪县",
      "value": 8018
    }, {
      "text": "旬阳县",
      "value": 8019
    }, {
      "text": "汉滨区",
      "value": 8011
    }, {
      "text": "岚皋县",
      "value": 8016
    }, {
      "text": "白河县",
      "value": 8021
    }]
  }, {
    "text": "商洛市",
    "value": 1109,
    "children": [{
      "text": "商州区",
      "value": 8031
    }, {
      "text": "洛南县",
      "value": 8032
    }, {
      "text": "丹凤县",
      "value": 8033
    }, {
      "text": "商南县",
      "value": 8034
    }, {
      "text": "镇安县",
      "value": 8036
    }, {
      "text": "柞水县",
      "value": 8037
    }, {
      "text": "山阳县",
      "value": 8035
    }]
  }, {
    "text": "延安市",
    "value": 1110,
    "children": [{
      "text": "洛川县",
      "value": 8051
    }, {
      "text": "宜川县",
      "value": 8052
    }, {
      "text": "黄龙县",
      "value": 8053
    }, {
      "text": "黄陵县",
      "value": 8054
    }, {
      "text": "宝塔区",
      "value": 8041
    }, {
      "text": "延川县",
      "value": 8043
    }, {
      "text": "子长县",
      "value": 8044
    }, {
      "text": "安塞区",
      "value": 8045
    }, {
      "text": "志丹县",
      "value": 8046
    }, {
      "text": "甘泉县",
      "value": 8048
    }, {
      "text": "富　县",
      "value": 8049
    }, {
      "text": "延长县",
      "value": 8042
    }, {
      "text": "吴起县",
      "value": 8047
    }]
  }, {
    "text": "汉中市",
    "value": 1107,
    "children": [{
      "text": "汉台区",
      "value": 7991
    }, {
      "text": "南郑区",
      "value": 7992
    }, {
      "text": "洋  县",
      "value": 7994
    }, {
      "text": "西乡县",
      "value": 7995
    }, {
      "text": "勉  县",
      "value": 7996
    }, {
      "text": "宁强县",
      "value": 7997
    }, {
      "text": "镇巴县",
      "value": 7999
    }, {
      "text": "留坝县",
      "value": 8001
    }, {
      "text": "佛坪县",
      "value": 8002
    }, {
      "text": "城固县",
      "value": 7993
    }, {
      "text": "略阳县",
      "value": 7998
    }]
  }]
}, {
  "text": "北京市",
  "value": 14,
  "children": [{
    "text": "北京市",
    "value": 545,
    "children": [{
      "text": "东城区",
      "value": 1021
    }, {
      "text": "西城区",
      "value": 1022
    }, {
      "text": "朝阳区",
      "value": 1023
    }, {
      "text": "丰台区",
      "value": 1024
    }, {
      "text": "石景山区",
      "value": 1025
    }, {
      "text": "海淀区",
      "value": 1026
    }, {
      "text": "密云区",
      "value": 1027
    }, {
      "text": "延庆区",
      "value": 1028
    }, {
      "text": "门头沟区",
      "value": 1029
    }, {
      "text": "通州区",
      "value": 1031
    }, {
      "text": "顺义区",
      "value": 1032
    }, {
      "text": "昌平区",
      "value": 1033
    }, {
      "text": "大兴区",
      "value": 1034
    }, {
      "text": "平谷区",
      "value": 1035
    }, {
      "text": "房山区",
      "value": 1036
    }, {
      "text": "怀柔区",
      "value": 1039
    }]
  }]
}, {
  "text": "天津市",
  "value": 15,
  "children": [{
    "text": "天津市",
    "value": 546,
    "children": [{
      "text": "宁河区",
      "value": 1121
    }, {
      "text": "静海区",
      "value": 1123
    }, {
      "text": "北辰区",
      "value": 1124
    }, {
      "text": "蓟州区",
      "value": 1125
    }, {
      "text": "宝坻区",
      "value": 1126
    }, {
      "text": "滨海新区",
      "value": 1127
    }, {
      "text": "和平区",
      "value": 1128
    }, {
      "text": "河东区",
      "value": 1129
    }, {
      "text": "河西区",
      "value": 1131
    }, {
      "text": "南开区",
      "value": 1132
    }, {
      "text": "河北区",
      "value": 1133
    }, {
      "text": "红桥区",
      "value": 1134
    }, {
      "text": "东丽区",
      "value": 1135
    }, {
      "text": "西青区",
      "value": 1136
    }, {
      "text": "津南区",
      "value": 1137
    }, {
      "text": "武清区",
      "value": 1138
    }]
  }]
}, {
  "text": "河北省",
  "value": 16,
  "children": [{
    "text": "石家庄市",
    "value": 1180,
    "children": [{
      "text": "井陉县",
      "value": 1211
    }, {
      "text": "鹿泉区",
      "value": 1212
    }, {
      "text": "正定县",
      "value": 1213
    }, {
      "text": "栾城区",
      "value": 1214
    }, {
      "text": "长安区",
      "value": 1215
    }, {
      "text": "桥西区",
      "value": 1216
    }, {
      "text": "新华区",
      "value": 1217
    }, {
      "text": "井陉矿区",
      "value": 1218
    }, {
      "text": "裕华区",
      "value": 1219
    }, {
      "text": "辛集市",
      "value": 1221
    }, {
      "text": "晋州市",
      "value": 1222
    }, {
      "text": "深泽县",
      "value": 1223
    }, {
      "text": "无极县",
      "value": 1224
    }, {
      "text": "藁城区",
      "value": 1225
    }, {
      "text": "新乐市",
      "value": 1227
    }, {
      "text": "高邑县",
      "value": 1228
    }, {
      "text": "赞皇县",
      "value": 1231
    }, {
      "text": "平山县",
      "value": 1232
    }, {
      "text": "灵寿县",
      "value": 1233
    }, {
      "text": "赵县",
      "value": 1226
    }, {
      "text": "元氏县",
      "value": 1229
    }, {
      "text": "行唐县",
      "value": 1234
    }]
  }, {
    "text": "唐山市",
    "value": 1181,
    "children": [{
      "text": "路南区",
      "value": 1241
    }, {
      "text": "路北区",
      "value": 1242
    }, {
      "text": "滦州市",
      "value": 1243
    }, {
      "text": "乐亭县",
      "value": 1245
    }, {
      "text": "迁安市",
      "value": 1246
    }, {
      "text": "迁西县",
      "value": 1247
    }, {
      "text": "遵化市",
      "value": 1248
    }, {
      "text": "丰南区",
      "value": 1251
    }, {
      "text": "古冶区",
      "value": 1252
    }, {
      "text": "开平区",
      "value": 1253
    }, {
      "text": "曹妃甸区",
      "value": 1255
    }, {
      "text": "滦南县",
      "value": 1244
    }, {
      "text": "玉田县",
      "value": 1249
    }, {
      "text": "丰润区",
      "value": 1254
    }]
  }, {
    "text": "秦皇岛市",
    "value": 1182,
    "children": [{
      "text": "青龙满族自治县",
      "value": 1261
    }, {
      "text": "昌黎县",
      "value": 1262
    }, {
      "text": "卢龙县",
      "value": 1264
    }, {
      "text": "海港区",
      "value": 1265
    }, {
      "text": "北戴河区",
      "value": 1267
    }, {
      "text": "抚宁区",
      "value": 1263
    }, {
      "text": "山海关区",
      "value": 1266
    }]
  }, {
    "text": "邯郸市",
    "value": 1183,
    "children": [{
      "text": "邯山区",
      "value": 1272
    }, {
      "text": "丛台区",
      "value": 1273
    }, {
      "text": "复兴区",
      "value": 1274
    }, {
      "text": "大名县",
      "value": 1281
    }, {
      "text": "魏县",
      "value": 1282
    }, {
      "text": "曲周县",
      "value": 1283
    }, {
      "text": "邱县",
      "value": 1284
    }, {
      "text": "肥乡区",
      "value": 1286
    }, {
      "text": "广平县",
      "value": 1287
    }, {
      "text": "成安县",
      "value": 1288
    }, {
      "text": "临漳县",
      "value": 1289
    }, {
      "text": "涉县",
      "value": 1292
    }, {
      "text": "永年区",
      "value": 1293
    }, {
      "text": "馆陶县",
      "value": 1294
    }, {
      "text": "峰峰矿区",
      "value": 1275
    }, {
      "text": "鸡泽县",
      "value": 1285
    }, {
      "text": "磁县",
      "value": 1291
    }, {
      "text": "武安市",
      "value": 1295
    }]
  }, {
    "text": "邢台市",
    "value": 1184,
    "children": [{
      "text": "邢台县",
      "value": 1311
    }, {
      "text": "桥东区",
      "value": 1312
    }, {
      "text": "桥西区",
      "value": 1313
    }, {
      "text": "沙河市",
      "value": 1322
    }, {
      "text": "临城县",
      "value": 1323
    }, {
      "text": "内丘县",
      "value": 1324
    }, {
      "text": "柏乡县",
      "value": 1325
    }, {
      "text": "任县",
      "value": 1327
    }, {
      "text": "南和县",
      "value": 1328
    }, {
      "text": "宁晋县",
      "value": 1329
    }, {
      "text": "新河县",
      "value": 1332
    }, {
      "text": "广宗县",
      "value": 1333
    }, {
      "text": "平乡县",
      "value": 1334
    }, {
      "text": "威县",
      "value": 1335
    }, {
      "text": "临西县",
      "value": 1337
    }, {
      "text": "南宫市",
      "value": 1321
    }, {
      "text": "隆尧县",
      "value": 1326
    }, {
      "text": "巨鹿县",
      "value": 1331
    }, {
      "text": "清河县",
      "value": 1336
    }]
  }, {
    "text": "保定市",
    "value": 1185,
    "children": [{
      "text": "满城区",
      "value": 1341
    }, {
      "text": "清苑区",
      "value": 1342
    }, {
      "text": "莲池区",
      "value": 1344
    }, {
      "text": "定州市",
      "value": 1351
    }, {
      "text": "涿州市",
      "value": 1352
    }, {
      "text": "易县",
      "value": 1353
    }, {
      "text": "涞源县",
      "value": 1355
    }, {
      "text": "定兴县",
      "value": 1356
    }, {
      "text": "顺平县",
      "value": 1357
    }, {
      "text": "望都县",
      "value": 1359
    }, {
      "text": "涞水县",
      "value": 1361
    }, {
      "text": "高阳县",
      "value": 1362
    }, {
      "text": "雄县",
      "value": 1364
    }, {
      "text": "容城县",
      "value": 1365
    }, {
      "text": "高碑店市",
      "value": 1366
    }, {
      "text": "曲阳县",
      "value": 1367
    }, {
      "text": "安国市",
      "value": 1369
    }, {
      "text": "博野县",
      "value": 1371
    }, {
      "text": "蠡县",
      "value": 1372
    }, {
      "text": "新市区",
      "value": 1343
    }, {
      "text": "徐水区",
      "value": 1354
    }, {
      "text": "唐县",
      "value": 1358
    }, {
      "text": "安新县",
      "value": 1363
    }, {
      "text": "阜平县",
      "value": 1368
    }]
  }, {
    "text": "张家口市",
    "value": 1186,
    "children": [{
      "text": "桥东区",
      "value": 1382
    }, {
      "text": "桥西区",
      "value": 1383
    }, {
      "text": "宣化区",
      "value": 1384
    }, {
      "text": "下花园区",
      "value": 1385
    }, {
      "text": "张北县",
      "value": 1391
    }, {
      "text": "康保县",
      "value": 1392
    }, {
      "text": "沽源县",
      "value": 1393
    }, {
      "text": "尚义县",
      "value": 1394
    }, {
      "text": "蔚县",
      "value": 1395
    }, {
      "text": "阳原县",
      "value": 1396
    }, {
      "text": "怀安县",
      "value": 1397
    }, {
      "text": "万全区",
      "value": 1398
    }, {
      "text": "怀来县",
      "value": 1399
    }, {
      "text": "涿鹿县",
      "value": 1401
    }, {
      "text": "赤城县",
      "value": 1402
    }, {
      "text": "崇礼区",
      "value": 1403
    }]
  }, {
    "text": "承德市",
    "value": 1187,
    "children": [{
      "text": "承德县",
      "value": 1411
    }, {
      "text": "双桥区",
      "value": 1412
    }, {
      "text": "双滦区",
      "value": 1413
    }, {
      "text": "鹰手营子矿区",
      "value": 1414
    }, {
      "text": "宽城满族自治县",
      "value": 1421
    }, {
      "text": "兴隆县",
      "value": 1422
    }, {
      "text": "平泉市",
      "value": 1423
    }, {
      "text": "滦平县",
      "value": 1424
    }, {
      "text": "丰宁满族自治县",
      "value": 1425
    }, {
      "text": "隆化县",
      "value": 1426
    }, {
      "text": "围场满族蒙古族自治县",
      "value": 1427
    }]
  }, {
    "text": "沧州市",
    "value": 1188,
    "children": [{
      "text": "沧　县",
      "value": 1431
    }, {
      "text": "青　县",
      "value": 1432
    }, {
      "text": "新华区",
      "value": 1433
    }, {
      "text": "泊头市",
      "value": 1441
    }, {
      "text": "任丘市",
      "value": 1442
    }, {
      "text": "河间市",
      "value": 1443
    }, {
      "text": "肃宁县",
      "value": 1444
    }, {
      "text": "献　县",
      "value": 1445
    }, {
      "text": "吴桥县",
      "value": 1446
    }, {
      "text": "东光县",
      "value": 1447
    }, {
      "text": "南皮县",
      "value": 1448
    }, {
      "text": "盐山县",
      "value": 1449
    }, {
      "text": "黄骅市",
      "value": 1451
    }, {
      "text": "孟村回族自治县",
      "value": 1452
    }, {
      "text": "海兴县",
      "value": 1453
    }, {
      "text": "运河区",
      "value": 1454
    }]
  }, {
    "text": "廊坊市",
    "value": 1189,
    "children": [{
      "text": "三河市",
      "value": 1461
    }, {
      "text": "固安县",
      "value": 1462
    }, {
      "text": "永清县",
      "value": 1463
    }, {
      "text": "香河县",
      "value": 1464
    }, {
      "text": "大城县",
      "value": 1465
    }, {
      "text": "文安县",
      "value": 1466
    }, {
      "text": "霸州市",
      "value": 1467
    }, {
      "text": "大厂回族自治县",
      "value": 1468
    }, {
      "text": "安次区",
      "value": 1469
    }, {
      "text": "广阳区",
      "value": 1471
    }]
  }, {
    "text": "衡水市",
    "value": 1190,
    "children": [{
      "text": "桃城区",
      "value": 1481
    }, {
      "text": "冀州区",
      "value": 1482
    }, {
      "text": "枣强县",
      "value": 1483
    }, {
      "text": "武邑县",
      "value": 1484
    }, {
      "text": "深州市",
      "value": 1485
    }, {
      "text": "武强县",
      "value": 1486
    }, {
      "text": "饶阳县",
      "value": 1487
    }, {
      "text": "安平县",
      "value": 1488
    }, {
      "text": "故城县",
      "value": 1489
    }, {
      "text": "景　县",
      "value": 1491
    }, {
      "text": "阜城县",
      "value": 1492
    }]
  }]
}, {
  "text": "山西省",
  "value": 17,
  "children": [{
    "text": "太原市",
    "value": 1191,
    "children": [{
      "text": "清徐县",
      "value": 1611
    }, {
      "text": "阳曲县",
      "value": 1612
    }, {
      "text": "娄烦县",
      "value": 1613
    }, {
      "text": "古交市",
      "value": 1614
    }, {
      "text": "尖草坪区",
      "value": 1615
    }, {
      "text": "小店区",
      "value": 1616
    }, {
      "text": "迎泽区",
      "value": 1617
    }, {
      "text": "杏花岭区",
      "value": 1618
    }, {
      "text": "万柏林区",
      "value": 1619
    }, {
      "text": "晋源区",
      "value": 1621
    }]
  }, {
    "text": "大同市",
    "value": 1192,
    "children": [{
      "text": "阳高县",
      "value": 1631
    }, {
      "text": "天镇县",
      "value": 1632
    }, {
      "text": "广灵县",
      "value": 1633
    }, {
      "text": "灵丘县",
      "value": 1634
    }, {
      "text": "浑源县",
      "value": 1635
    }, {
      "text": "左云县",
      "value": 1637
    }, {
      "text": "云州区",
      "value": 1639
    }, {
      "text": "平城区",
      "value": 1641
    }, {
      "text": "云冈区",
      "value": 1642
    }, {
      "text": "新荣区",
      "value": 1643
    }]
  }, {
    "text": "阳泉市",
    "value": 1193,
    "children": [{
      "text": "平定县",
      "value": 1651
    }, {
      "text": "盂县",
      "value": 1652
    }, {
      "text": "城区",
      "value": 1653
    }, {
      "text": "矿区",
      "value": 1654
    }, {
      "text": "郊区",
      "value": 1655
    }]
  }, {
    "text": "长治市",
    "value": 1194,
    "children": [{
      "text": "上党区",
      "value": 1661
    }, {
      "text": "潞城区",
      "value": 1662
    }, {
      "text": "襄垣县",
      "value": 1663
    }, {
      "text": "屯留区",
      "value": 1664
    }, {
      "text": "平顺县",
      "value": 1665
    }, {
      "text": "黎城县",
      "value": 1666
    }, {
      "text": "壶关县",
      "value": 1667
    }, {
      "text": "长子县",
      "value": 1668
    }, {
      "text": "武乡县",
      "value": 1669
    }, {
      "text": "沁  县",
      "value": 1671
    }, {
      "text": "沁源县",
      "value": 1672
    }, {
      "text": "潞州区",
      "value": 1673
    }]
  }, {
    "text": "晋城市",
    "value": 1195,
    "children": [{
      "text": "沁水县",
      "value": 1681
    }, {
      "text": "阳城县",
      "value": 1682
    }, {
      "text": "高平市",
      "value": 1683
    }, {
      "text": "陵川县",
      "value": 1684
    }, {
      "text": "泽州县",
      "value": 1685
    }, {
      "text": "城  区",
      "value": 1686
    }]
  }, {
    "text": "朔州市",
    "value": 1196,
    "children": [{
      "text": "山阴县",
      "value": 1691
    }, {
      "text": "应  县",
      "value": 1692
    }, {
      "text": "右玉县",
      "value": 1693
    }, {
      "text": "怀仁市",
      "value": 1694
    }, {
      "text": "朔城区",
      "value": 1695
    }, {
      "text": "平鲁区",
      "value": 1696
    }]
  }, {
    "text": "忻州市",
    "value": 1197,
    "children": [{
      "text": "定襄县",
      "value": 1712
    }, {
      "text": "五台县",
      "value": 1713
    }, {
      "text": "原平市",
      "value": 1714
    }, {
      "text": "代  县",
      "value": 1715
    }, {
      "text": "繁峙县",
      "value": 1716
    }, {
      "text": "宁武县",
      "value": 1717
    }, {
      "text": "静乐县",
      "value": 1718
    }, {
      "text": "神池县",
      "value": 1719
    }, {
      "text": "五寨县",
      "value": 1721
    }, {
      "text": "岢岚县",
      "value": 1722
    }, {
      "text": "河曲县",
      "value": 1723
    }, {
      "text": "保德县",
      "value": 1724
    }, {
      "text": "偏关县",
      "value": 1725
    }, {
      "text": "忻府区",
      "value": 1726
    }]
  }, {
    "text": "吕梁市",
    "value": 1198,
    "children": [{
      "text": "汾阳市",
      "value": 1731
    }, {
      "text": "文水县",
      "value": 1732
    }, {
      "text": "交城县",
      "value": 1733
    }, {
      "text": "孝义市",
      "value": 1734
    }, {
      "text": "兴  县",
      "value": 1735
    }, {
      "text": "临  县",
      "value": 1736
    }, {
      "text": "柳林县",
      "value": 1737
    }, {
      "text": "石楼县",
      "value": 1738
    }, {
      "text": "岚  县",
      "value": 1739
    }, {
      "text": "中阳县",
      "value": 1743
    }, {
      "text": "交口县",
      "value": 1744
    }, {
      "text": "离石区",
      "value": 1745
    }, {
      "text": "方山县",
      "value": 1741
    }]
  }, {
    "text": "晋中市",
    "value": 1199,
    "children": [{
      "text": "榆次区",
      "value": 1751
    }, {
      "text": "左权县",
      "value": 1753
    }, {
      "text": "和顺县",
      "value": 1754
    }, {
      "text": "昔阳县",
      "value": 1755
    }, {
      "text": "太谷县",
      "value": 1757
    }, {
      "text": "祁  县",
      "value": 1758
    }, {
      "text": "平遥县",
      "value": 1759
    }, {
      "text": "介休市",
      "value": 1761
    }, {
      "text": "榆社县",
      "value": 1752
    }, {
      "text": "寿阳县",
      "value": 1756
    }, {
      "text": "灵石县",
      "value": 1762
    }]
  }, {
    "text": "临汾市",
    "value": 1200,
    "children": [{
      "text": "尧都区",
      "value": 1771
    }, {
      "text": "侯马市",
      "value": 1772
    }, {
      "text": "曲沃县",
      "value": 1773
    }, {
      "text": "襄汾县",
      "value": 1775
    }, {
      "text": "洪洞县",
      "value": 1776
    }, {
      "text": "霍州市",
      "value": 1777
    }, {
      "text": "古  县",
      "value": 1778
    }, {
      "text": "浮山县",
      "value": 1781
    }, {
      "text": "吉  县",
      "value": 1782
    }, {
      "text": "乡宁县",
      "value": 1783
    }, {
      "text": "大宁县",
      "value": 1785
    }, {
      "text": "永和县",
      "value": 1786
    }, {
      "text": "隰  县",
      "value": 1787
    }, {
      "text": "翼城县",
      "value": 1774
    }, {
      "text": "安泽县",
      "value": 1779
    }, {
      "text": "蒲  县",
      "value": 1784
    }, {
      "text": "汾西县",
      "value": 1788
    }]
  }, {
    "text": "运城市",
    "value": 1201,
    "children": [{
      "text": "盐湖区",
      "value": 1811
    }, {
      "text": "永济市",
      "value": 1812
    }, {
      "text": "芮城县",
      "value": 1813
    }, {
      "text": "临猗县",
      "value": 1814
    }, {
      "text": "新绛县",
      "value": 1816
    }, {
      "text": "稷山县",
      "value": 1817
    }, {
      "text": "河津市",
      "value": 1818
    }, {
      "text": "夏  县",
      "value": 1821
    }, {
      "text": "绛  县",
      "value": 1822
    }, {
      "text": "平陆县",
      "value": 1823
    }, {
      "text": "垣曲县",
      "value": 1824
    }, {
      "text": "万荣县",
      "value": 1815
    }, {
      "text": "闻喜县",
      "value": 1819
    }]
  }]
}, {
  "text": "内蒙古自治区",
  "value": 18,
  "children": [{
    "text": "呼和浩特市",
    "value": 1202,
    "children": [{
      "text": "托克托县",
      "value": 1912
    }, {
      "text": "武川县",
      "value": 1913
    }, {
      "text": "和林格尔县",
      "value": 1914
    }, {
      "text": "回民区",
      "value": 1916
    }, {
      "text": "如意开发区",
      "value": 1917
    }, {
      "text": "赛罕区",
      "value": 1918
    }, {
      "text": "玉泉区",
      "value": 2061
    }, {
      "text": "土默特左旗",
      "value": 1911
    }, {
      "text": "清水河县",
      "value": 1915
    }, {
      "text": "新城区",
      "value": 1919
    }]
  }, {
    "text": "包头市",
    "value": 1203,
    "children": [{
      "text": "土默特右旗",
      "value": 1921
    }, {
      "text": "固阳县",
      "value": 1922
    }, {
      "text": "达尔罕茂明安联合旗",
      "value": 1923
    }, {
      "text": "昆都仑区",
      "value": 1925
    }, {
      "text": "青山区",
      "value": 1926
    }, {
      "text": "石拐区",
      "value": 1927
    }, {
      "text": "白云鄂博矿区",
      "value": 1928
    }, {
      "text": "东河区",
      "value": 1924
    }, {
      "text": "九原区",
      "value": 1929
    }]
  }, {
    "text": "乌海市",
    "value": 1204,
    "children": [{
      "text": "海勃湾区",
      "value": 1931
    }, {
      "text": "海南区",
      "value": 1932
    }, {
      "text": "乌达区",
      "value": 1933
    }]
  }, {
    "text": "赤峰市",
    "value": 1205,
    "children": [{
      "text": "阿鲁科尔沁旗",
      "value": 1941
    }, {
      "text": "巴林左旗",
      "value": 1942
    }, {
      "text": "林西县",
      "value": 1944
    }, {
      "text": "克什克腾旗",
      "value": 1945
    }, {
      "text": "翁牛特旗",
      "value": 1946
    }, {
      "text": "喀喇沁旗",
      "value": 1947
    }, {
      "text": "敖汉旗",
      "value": 1949
    }, {
      "text": "红山区",
      "value": 1951
    }, {
      "text": "元宝山区",
      "value": 1952
    }, {
      "text": "松山区",
      "value": 1953
    }, {
      "text": "巴林右旗",
      "value": 1943
    }, {
      "text": "宁城县",
      "value": 1948
    }]
  }, {
    "text": "呼伦贝尔市",
    "value": 1206,
    "children": [{
      "text": "满洲里市",
      "value": 1962
    }, {
      "text": "扎兰屯市",
      "value": 1963
    }, {
      "text": "牙克石市",
      "value": 1964
    }, {
      "text": "阿荣旗",
      "value": 1965
    }, {
      "text": "莫力达瓦达斡尔族自治旗",
      "value": 1966
    }, {
      "text": "额尔古纳市",
      "value": 1967
    }, {
      "text": "根河市",
      "value": 1968
    }, {
      "text": "鄂伦春自治旗",
      "value": 1969
    }, {
      "text": "鄂温克族自治旗",
      "value": 1971
    }, {
      "text": "新巴尔虎右旗",
      "value": 1972
    }, {
      "text": "新巴尔虎左旗",
      "value": 1973
    }, {
      "text": "陈巴尔虎旗",
      "value": 1974
    }, {
      "text": "扎赉诺尔区",
      "value": 1975
    }, {
      "text": "海拉尔区",
      "value": 1961
    }]
  }, {
    "text": "兴安盟",
    "value": 1207,
    "children": [{
      "text": "乌兰浩特市",
      "value": 1981
    }, {
      "text": "科尔沁右翼前旗",
      "value": 1982
    }, {
      "text": "科尔沁右翼中旗",
      "value": 1983
    }, {
      "text": "扎赉特旗",
      "value": 1984
    }, {
      "text": "突泉县",
      "value": 1985
    }, {
      "text": "阿尔山市",
      "value": 1986
    }]
  }, {
    "text": "通辽市",
    "value": 1208,
    "children": [{
      "text": "科尔沁区",
      "value": 1991
    }, {
      "text": "霍林郭勒市",
      "value": 1992
    }, {
      "text": "科尔沁左翼中旗",
      "value": 1993
    }, {
      "text": "科尔沁左翼后旗",
      "value": 1994
    }, {
      "text": "开鲁县",
      "value": 1995
    }, {
      "text": "库伦旗",
      "value": 1996
    }, {
      "text": "奈曼旗",
      "value": 1997
    }, {
      "text": "扎鲁特旗",
      "value": 1998
    }]
  }, {
    "text": "锡林郭勒盟",
    "value": 1209,
    "children": [{
      "text": "二连浩特市",
      "value": 2011
    }, {
      "text": "锡林浩特市",
      "value": 2012
    }, {
      "text": "阿巴嘎旗",
      "value": 2013
    }, {
      "text": "苏尼特左旗",
      "value": 2014
    }, {
      "text": "苏尼特右旗",
      "value": 2015
    }, {
      "text": "东乌珠穆沁旗",
      "value": 2016
    }, {
      "text": "西乌珠穆沁旗",
      "value": 2017
    }, {
      "text": "太仆寺旗",
      "value": 2018
    }, {
      "text": "镶黄旗",
      "value": 2019
    }, {
      "text": "正镶白旗",
      "value": 2021
    }, {
      "text": "正蓝旗",
      "value": 2022
    }, {
      "text": "多伦县",
      "value": 2023
    }]
  }, {
    "text": "乌兰察布市",
    "value": 1210,
    "children": [{
      "text": "集宁区",
      "value": 2031
    }, {
      "text": "卓资县",
      "value": 2035
    }, {
      "text": "化德县",
      "value": 2036
    }, {
      "text": "商都县",
      "value": 2037
    }, {
      "text": "兴和县",
      "value": 2038
    }, {
      "text": "丰镇市",
      "value": 2039
    }, {
      "text": "凉城县",
      "value": 2041
    }, {
      "text": "察哈尔右翼前旗",
      "value": 2042
    }, {
      "text": "察哈尔右翼中旗",
      "value": 2043
    }, {
      "text": "察哈尔右翼后旗",
      "value": 2044
    }, {
      "text": "四子王旗",
      "value": 2046
    }]
  }, {
    "text": "鄂尔多斯市",
    "value": 1211,
    "children": [{
      "text": "东胜区",
      "value": 2051
    }, {
      "text": "达拉特旗",
      "value": 2052
    }, {
      "text": "准格尔旗",
      "value": 2053
    }, {
      "text": "鄂托克前旗",
      "value": 2054
    }, {
      "text": "鄂托克旗",
      "value": 2055
    }, {
      "text": "杭锦旗",
      "value": 2056
    }, {
      "text": "乌审旗",
      "value": 2057
    }, {
      "text": "伊金霍洛旗",
      "value": 2058
    }, {
      "text": "康巴什区",
      "value": 2059
    }]
  }, {
    "text": "巴彦淖尔市",
    "value": 1212,
    "children": [{
      "text": "临河区",
      "value": 2071
    }, {
      "text": "五原县",
      "value": 2072
    }, {
      "text": "磴口县",
      "value": 2073
    }, {
      "text": "乌拉特前旗",
      "value": 2074
    }, {
      "text": "乌拉特中旗",
      "value": 2075
    }, {
      "text": "乌拉特后旗",
      "value": 2076
    }, {
      "text": "杭锦后旗",
      "value": 2077
    }]
  }, {
    "text": "阿拉善盟",
    "value": 1213,
    "children": [{
      "text": "阿拉善左旗",
      "value": 2081
    }, {
      "text": "阿拉善右旗",
      "value": 2082
    }, {
      "text": "额济纳旗",
      "value": 2083
    }]
  }]
}, {
  "text": "辽宁省",
  "value": 19,
  "children": [{
    "text": "沈阳市",
    "value": 1214,
    "children": [{
      "text": "新民市",
      "value": 2211
    }, {
      "text": "辽中区",
      "value": 2212
    }, {
      "text": "康平县",
      "value": 2213
    }, {
      "text": "法库县",
      "value": 2214
    }, {
      "text": "沈北新区",
      "value": 2215
    }, {
      "text": "和平区",
      "value": 2216
    }, {
      "text": "沈河区",
      "value": 2217
    }, {
      "text": "大东区",
      "value": 2218
    }, {
      "text": "皇姑区",
      "value": 2219
    }, {
      "text": "铁西区",
      "value": 2351
    }, {
      "text": "苏家屯区",
      "value": 2352
    }, {
      "text": "浑南区",
      "value": 2353
    }, {
      "text": "于洪区",
      "value": 2354
    }]
  }, {
    "text": "大连市",
    "value": 1215,
    "children": [{
      "text": "普兰店区",
      "value": 2221
    }, {
      "text": "长海县",
      "value": 2222
    }, {
      "text": "庄河市",
      "value": 2223
    }, {
      "text": "瓦房店市",
      "value": 2224
    }, {
      "text": "中山区",
      "value": 2225
    }, {
      "text": "西岗区",
      "value": 2226
    }, {
      "text": "沙河口区",
      "value": 2227
    }, {
      "text": "甘井子区",
      "value": 2228
    }, {
      "text": "旅顺口区",
      "value": 2229
    }, {
      "text": "金州区",
      "value": 2371
    }]
  }, {
    "text": "鞍山市",
    "value": 1216,
    "children": [{
      "text": "台安县",
      "value": 2231
    }, {
      "text": "海城市",
      "value": 2232
    }, {
      "text": "岫岩满族自治县",
      "value": 2233
    }, {
      "text": "铁东区",
      "value": 2234
    }, {
      "text": "铁西区",
      "value": 2235
    }, {
      "text": "立山区",
      "value": 2236
    }, {
      "text": "千山区",
      "value": 2237
    }]
  }, {
    "text": "抚顺市",
    "value": 1217,
    "children": [{
      "text": "抚顺县",
      "value": 2241
    }, {
      "text": "新宾满族自治县",
      "value": 2242
    }, {
      "text": "清原满族自治县",
      "value": 2243
    }, {
      "text": "新抚区",
      "value": 2244
    }, {
      "text": "望花区",
      "value": 2246
    }, {
      "text": "顺城区",
      "value": 2247
    }, {
      "text": "东洲区",
      "value": 2245
    }]
  }, {
    "text": "本溪市",
    "value": 1218,
    "children": [{
      "text": "本溪满族自治县",
      "value": 2251
    }, {
      "text": "桓仁满族自治县",
      "value": 2252
    }, {
      "text": "溪湖区",
      "value": 2254
    }, {
      "text": "明山区",
      "value": 2255
    }, {
      "text": "南芬区",
      "value": 2256
    }, {
      "text": "平山区",
      "value": 2253
    }]
  }, {
    "text": "丹东市",
    "value": 1219,
    "children": [{
      "text": "东港市",
      "value": 2263
    }, {
      "text": "宽甸满族自治县",
      "value": 2264
    }, {
      "text": "元宝区",
      "value": 2265
    }, {
      "text": "振安区",
      "value": 2266
    }, {
      "text": "凤城市",
      "value": 2261
    }, {
      "text": "振兴区",
      "value": 2267
    }]
  }, {
    "text": "锦州市",
    "value": 1220,
    "children": [{
      "text": "太和区",
      "value": 2271
    }, {
      "text": "凌海市",
      "value": 2272
    }, {
      "text": "北镇市",
      "value": 2273
    }, {
      "text": "义　县",
      "value": 2275
    }, {
      "text": "古塔区",
      "value": 2276
    }, {
      "text": "凌河区",
      "value": 2277
    }, {
      "text": "黑山县",
      "value": 2274
    }]
  }, {
    "text": "营口市",
    "value": 1221,
    "children": [{
      "text": "大石桥市",
      "value": 2281
    }, {
      "text": "站前区",
      "value": 2283
    }, {
      "text": "西市区",
      "value": 2284
    }, {
      "text": "鲅鱼圈区",
      "value": 2285
    }, {
      "text": "盖州市",
      "value": 2282
    }, {
      "text": "老边区",
      "value": 2286
    }]
  }, {
    "text": "阜新市",
    "value": 1222,
    "children": [{
      "text": "阜新蒙古族自治县",
      "value": 2291
    }, {
      "text": "彰武县",
      "value": 2292
    }, {
      "text": "海州区",
      "value": 2293
    }, {
      "text": "新邱区",
      "value": 2294
    }, {
      "text": "清河门区",
      "value": 2296
    }, {
      "text": "细河区",
      "value": 2297
    }, {
      "text": "太平区",
      "value": 2295
    }]
  }, {
    "text": "辽阳市",
    "value": 1223,
    "children": [{
      "text": "辽阳县",
      "value": 2311
    }, {
      "text": "白塔区",
      "value": 2313
    }, {
      "text": "文圣区",
      "value": 2314
    }, {
      "text": "宏伟区",
      "value": 2315
    }, {
      "text": "弓长岭区",
      "value": 2316
    }, {
      "text": "灯塔市",
      "value": 2312
    }, {
      "text": "太子河区",
      "value": 2317
    }]
  }, {
    "text": "盘锦市",
    "value": 1224,
    "children": [{
      "text": "大洼区",
      "value": 2321
    }, {
      "text": "盘山县",
      "value": 2322
    }, {
      "text": "双台子区",
      "value": 2323
    }, {
      "text": "兴隆台区",
      "value": 2324
    }]
  }, {
    "text": "铁岭市",
    "value": 1225,
    "children": [{
      "text": "西丰县",
      "value": 2332
    }, {
      "text": "昌图县",
      "value": 2333
    }, {
      "text": "调兵山市",
      "value": 2336
    }, {
      "text": "银州区",
      "value": 2338
    }, {
      "text": "清河区",
      "value": 2339
    }, {
      "text": "铁岭县",
      "value": 2331
    }, {
      "text": "开原市",
      "value": 2337
    }]
  }, {
    "text": "朝阳市",
    "value": 1226,
    "children": [{
      "text": "朝阳县",
      "value": 2341
    }, {
      "text": "建平县",
      "value": 2342
    }, {
      "text": "喀喇沁左翼蒙古族自治县",
      "value": 2344
    }, {
      "text": "龙城区",
      "value": 2345
    }, {
      "text": "北票市",
      "value": 2346
    }, {
      "text": "凌源市",
      "value": 2343
    }, {
      "text": "双塔区",
      "value": 2347
    }]
  }, {
    "text": "葫芦岛市",
    "value": 1227,
    "children": [{
      "text": "绥中县",
      "value": 2361
    }, {
      "text": "建昌县",
      "value": 2362
    }, {
      "text": "兴城市",
      "value": 2363
    }, {
      "text": "龙港区",
      "value": 2365
    }, {
      "text": "南票区",
      "value": 2366
    }, {
      "text": "连山区",
      "value": 2364
    }]
  }]
}, {
  "text": "吉林省",
  "value": 20,
  "children": [{
    "text": "长春市",
    "value": 1228,
    "children": [{
      "text": "农安县",
      "value": 2412
    }, {
      "text": "德惠市",
      "value": 2413
    }, {
      "text": "九台区",
      "value": 2415
    }, {
      "text": "南关区",
      "value": 2416
    }, {
      "text": "朝阳区",
      "value": 2418
    }, {
      "text": "二道区",
      "value": 2419
    }, {
      "text": "绿园区",
      "value": 2481
    }, {
      "text": "长春新区",
      "value": 2483
    }, {
      "text": "榆树市",
      "value": 2411
    }, {
      "text": "宽城区",
      "value": 2417
    }, {
      "text": "双阳区",
      "value": 2482
    }]
  }, {
    "text": "吉林市",
    "value": 1229,
    "children": [{
      "text": "永吉县",
      "value": 2421
    }, {
      "text": "舒兰市",
      "value": 2422
    }, {
      "text": "磐石市",
      "value": 2423
    }, {
      "text": "桦甸市",
      "value": 2425
    }, {
      "text": "丰满区",
      "value": 2426
    }, {
      "text": "昌邑区",
      "value": 2427
    }, {
      "text": "船营区",
      "value": 2429
    }, {
      "text": "蛟河市",
      "value": 2424
    }, {
      "text": "龙潭区",
      "value": 2428
    }]
  }, {
    "text": "四平市",
    "value": 1230,
    "children": [{
      "text": "梨树县",
      "value": 2431
    }, {
      "text": "伊通满族自治县",
      "value": 2432
    }, {
      "text": "双辽市",
      "value": 2433
    }, {
      "text": "铁西区",
      "value": 2435
    }, {
      "text": "铁东区",
      "value": 2436
    }, {
      "text": "公主岭市",
      "value": 2434
    }]
  }, {
    "text": "辽源市",
    "value": 1231,
    "children": [{
      "text": "东丰县",
      "value": 2441
    }, {
      "text": "东辽县",
      "value": 2442
    }, {
      "text": "西安区",
      "value": 2444
    }, {
      "text": "龙山区",
      "value": 2443
    }]
  }, {
    "text": "通化市",
    "value": 1232,
    "children": [{
      "text": "集安市",
      "value": 2455
    }, {
      "text": "东昌区",
      "value": 2456
    }, {
      "text": "二道江区",
      "value": 2457
    }, {
      "text": "通化县",
      "value": 2451
    }, {
      "text": "辉南县",
      "value": 2452
    }, {
      "text": "梅河口市",
      "value": 2454
    }, {
      "text": "柳河县",
      "value": 2453
    }]
  }, {
    "text": "白山市",
    "value": 1233,
    "children": [{
      "text": "抚松县",
      "value": 2461
    }, {
      "text": "靖宇县",
      "value": 2462
    }, {
      "text": "长白朝鲜族自治县",
      "value": 2463
    }, {
      "text": "临江市",
      "value": 2464
    }, {
      "text": "浑江区",
      "value": 2465
    }, {
      "text": "江源区",
      "value": 2466
    }]
  }, {
    "text": "白城市",
    "value": 1234,
    "children": [{
      "text": "洮北区",
      "value": 2471
    }, {
      "text": "洮南市",
      "value": 2472
    }, {
      "text": "大安市",
      "value": 2474
    }, {
      "text": "镇赉县",
      "value": 2477
    }, {
      "text": "通榆县",
      "value": 2478
    }]
  }, {
    "text": "延边朝鲜族自治州",
    "value": 1235,
    "children": [{
      "text": "延吉市",
      "value": 2491
    }, {
      "text": "图们市",
      "value": 2492
    }, {
      "text": "敦化市",
      "value": 2493
    }, {
      "text": "珲春市",
      "value": 2494
    }, {
      "text": "龙井市",
      "value": 2495
    }, {
      "text": "和龙市",
      "value": 2496
    }, {
      "text": "汪清县",
      "value": 2497
    }, {
      "text": "安图县",
      "value": 2498
    }]
  }, {
    "text": "松原市",
    "value": 1236,
    "children": [{
      "text": "扶余市",
      "value": 2511
    }, {
      "text": "长岭县",
      "value": 2512
    }, {
      "text": "前郭尔罗斯蒙古族自治县",
      "value": 2513
    }, {
      "text": "乾安县",
      "value": 2514
    }, {
      "text": "宁江区",
      "value": 2515
    }]
  }]
}, {
  "text": "黑龙江省",
  "value": 21,
  "children": [{
    "text": "哈尔滨市",
    "value": 1237,
    "children": [{
      "text": "依兰县",
      "value": 2613
    }, {
      "text": "双城区",
      "value": 2621
    }, {
      "text": "尚志市",
      "value": 2622
    }, {
      "text": "宾　县",
      "value": 2623
    }, {
      "text": "五常市",
      "value": 2624
    }, {
      "text": "巴彦县",
      "value": 2625
    }, {
      "text": "木兰县",
      "value": 2626
    }, {
      "text": "通河县",
      "value": 2627
    }, {
      "text": "方正县",
      "value": 2628
    }, {
      "text": "延寿县",
      "value": 2629
    }, {
      "text": "道里区",
      "value": 2631
    }, {
      "text": "南岗区",
      "value": 2632
    }, {
      "text": "道外区",
      "value": 2633
    }, {
      "text": "平房区",
      "value": 2634
    }, {
      "text": "松北区",
      "value": 2635
    }, {
      "text": "香坊区",
      "value": 2636
    }, {
      "text": "呼兰区",
      "value": 2637
    }, {
      "text": "阿城区",
      "value": 2638
    }]
  }, {
    "text": "齐齐哈尔市",
    "value": 1238,
    "children": [{
      "text": "龙江县",
      "value": 2641
    }, {
      "text": "讷河市",
      "value": 2642
    }, {
      "text": "依安县",
      "value": 2643
    }, {
      "text": "泰来县",
      "value": 2644
    }, {
      "text": "甘南县",
      "value": 2645
    }, {
      "text": "富裕县",
      "value": 2647
    }, {
      "text": "克山县",
      "value": 2649
    }, {
      "text": "克东县",
      "value": 2651
    }, {
      "text": "拜泉县",
      "value": 2652
    }, {
      "text": "龙沙区",
      "value": 2653
    }, {
      "text": "建华区",
      "value": 2654
    }, {
      "text": "铁锋区",
      "value": 2655
    }, {
      "text": "昂昂溪区",
      "value": 2656
    }, {
      "text": "富拉尔基区",
      "value": 2657
    }, {
      "text": "碾子山区",
      "value": 2658
    }, {
      "text": "梅里斯达斡尔族区",
      "value": 2659
    }]
  }, {
    "text": "鸡西市",
    "value": 1239,
    "children": [{
      "text": "鸡东县",
      "value": 2661
    }, {
      "text": "虎林市",
      "value": 2662
    }, {
      "text": "密山市",
      "value": 2663
    }, {
      "text": "鸡冠区",
      "value": 2664
    }, {
      "text": "恒山区",
      "value": 2665
    }, {
      "text": "滴道区",
      "value": 2666
    }, {
      "text": "梨树区",
      "value": 2667
    }, {
      "text": "城子河区",
      "value": 2668
    }, {
      "text": "麻山区",
      "value": 2669
    }]
  }, {
    "text": "鹤岗市",
    "value": 1240,
    "children": [{
      "text": "萝北县",
      "value": 2671
    }, {
      "text": "绥滨县",
      "value": 2672
    }, {
      "text": "向阳区",
      "value": 2673
    }, {
      "text": "工农区",
      "value": 2674
    }, {
      "text": "南山区",
      "value": 2675
    }, {
      "text": "兴安区",
      "value": 2676
    }, {
      "text": "东山区",
      "value": 2677
    }, {
      "text": "兴山区",
      "value": 2678
    }]
  }, {
    "text": "双鸭山市",
    "value": 1241,
    "children": [{
      "text": "集贤县",
      "value": 2681
    }, {
      "text": "宝清县",
      "value": 2682
    }, {
      "text": "饶河县",
      "value": 2683
    }, {
      "text": "友谊县",
      "value": 2684
    }, {
      "text": "尖山区",
      "value": 2685
    }, {
      "text": "岭东区",
      "value": 2686
    }, {
      "text": "四方台区",
      "value": 2687
    }, {
      "text": "宝山区",
      "value": 2688
    }]
  }, {
    "text": "大庆市",
    "value": 1242,
    "children": [{
      "text": "林甸县",
      "value": 2691
    }, {
      "text": "杜尔伯特蒙古族自治县",
      "value": 2692
    }, {
      "text": "肇源县",
      "value": 2693
    }, {
      "text": "肇州县",
      "value": 2694
    }, {
      "text": "萨尔图区",
      "value": 2695
    }, {
      "text": "龙凤区",
      "value": 2696
    }, {
      "text": "让胡路区",
      "value": 2697
    }, {
      "text": "红岗区",
      "value": 2698
    }, {
      "text": "大同区",
      "value": 2699
    }]
  }, {
    "text": "伊春市",
    "value": 1243,
    "children": [{
      "text": "嘉荫县",
      "value": 2711
    }, {
      "text": "铁力市",
      "value": 2712
    }, {
      "text": "伊春区",
      "value": 2713
    }, {
      "text": "南岔区",
      "value": 2714
    }, {
      "text": "友好区",
      "value": 2715
    }, {
      "text": "西林区",
      "value": 2716
    }, {
      "text": "翠峦区",
      "value": 2717
    }, {
      "text": "美溪区",
      "value": 2719
    }, {
      "text": "金山屯区",
      "value": 2811
    }, {
      "text": "五营区",
      "value": 2812
    }, {
      "text": "乌马河区",
      "value": 2813
    }, {
      "text": "带岭区",
      "value": 2815
    }, {
      "text": "乌伊岭区",
      "value": 2816
    }, {
      "text": "红星区",
      "value": 2817
    }, {
      "text": "上甘岭区",
      "value": 2818
    }, {
      "text": "新青区",
      "value": 2718
    }, {
      "text": "汤旺河区",
      "value": 2814
    }]
  }, {
    "text": "佳木斯市",
    "value": 1244,
    "children": [{
      "text": "桦川县",
      "value": 2723
    }, {
      "text": "汤原县",
      "value": 2725
    }, {
      "text": "抚远市",
      "value": 2727
    }, {
      "text": "富锦市",
      "value": 2731
    }, {
      "text": "向阳区",
      "value": 2732
    }, {
      "text": "前进区",
      "value": 2733
    }, {
      "text": "郊  区",
      "value": 2735
    }, {
      "text": "桦南县",
      "value": 2721
    }, {
      "text": "同江市",
      "value": 2729
    }, {
      "text": "东风区",
      "value": 2734
    }]
  }, {
    "text": "七台河市",
    "value": 1245,
    "children": [{
      "text": "勃利县",
      "value": 2741
    }, {
      "text": "新兴区",
      "value": 2742
    }, {
      "text": "茄子河区",
      "value": 2744
    }, {
      "text": "桃山区",
      "value": 2743
    }]
  }, {
    "text": "牡丹江市",
    "value": 1246,
    "children": [{
      "text": "宁安市",
      "value": 2751
    }, {
      "text": "海林市",
      "value": 2752
    }, {
      "text": "东宁市",
      "value": 2754
    }, {
      "text": "林口县",
      "value": 2755
    }, {
      "text": "东安区",
      "value": 2758
    }, {
      "text": "阳明区",
      "value": 2759
    }, {
      "text": "爱民区",
      "value": 2821
    }, {
      "text": "西安区",
      "value": 2822
    }, {
      "text": "穆棱市",
      "value": 2753
    }, {
      "text": "绥芬河市",
      "value": 2757
    }]
  }, {
    "text": "绥化市",
    "value": 1247,
    "children": [{
      "text": "安达市",
      "value": 2762
    }, {
      "text": "肇东市",
      "value": 2763
    }, {
      "text": "海伦市",
      "value": 2764
    }, {
      "text": "兰西县",
      "value": 2766
    }, {
      "text": "青冈县",
      "value": 2767
    }, {
      "text": "庆安县",
      "value": 2771
    }, {
      "text": "明水县",
      "value": 2772
    }, {
      "text": "北林区",
      "value": 2761
    }, {
      "text": "望奎县",
      "value": 2765
    }, {
      "text": "绥棱县",
      "value": 2773
    }]
  }, {
    "text": "黑河市",
    "value": 1248,
    "children": [{
      "text": "爱辉区",
      "value": 2781
    }, {
      "text": "北安市",
      "value": 2782
    }, {
      "text": "五大连池市",
      "value": 2783
    }, {
      "text": "嫩江县",
      "value": 2784
    }, {
      "text": "孙吴县",
      "value": 2787
    }, {
      "text": "逊克县",
      "value": 2786
    }]
  }, {
    "text": "大兴安岭地区",
    "value": 1249,
    "children": [{
      "text": "呼玛县",
      "value": 2791
    }, {
      "text": "漠河市",
      "value": 2793
    }, {
      "text": "塔河县",
      "value": 2792
    }]
  }]
}, {
  "text": "上海市",
  "value": 22,
  "children": [{
    "text": "上海市",
    "value": 547,
    "children": [{
      "text": "松江区",
      "value": 2901
    }, {
      "text": "青浦区",
      "value": 2902
    }, {
      "text": "奉贤区",
      "value": 2903
    }, {
      "text": "浦东新区",
      "value": 2904
    }, {
      "text": "金山区",
      "value": 2905
    }, {
      "text": "闵行区",
      "value": 2906
    }, {
      "text": "黄浦区",
      "value": 2907
    }, {
      "text": "徐汇区",
      "value": 2908
    }, {
      "text": "长宁区",
      "value": 2909
    }, {
      "text": "静安区",
      "value": 2911
    }, {
      "text": "普陀区",
      "value": 2912
    }, {
      "text": "虹口区",
      "value": 2914
    }, {
      "text": "杨浦区",
      "value": 2915
    }, {
      "text": "宝山区",
      "value": 2916
    }, {
      "text": "嘉定区",
      "value": 2917
    }, {
      "text": "崇明区",
      "value": 2929
    }]
  }]
}, {
  "text": "江苏省",
  "value": 23,
  "children": [{
    "text": "南京市",
    "value": 1266,
    "children": [{
      "text": "浦口区",
      "value": 3011
    }, {
      "text": "玄武区",
      "value": 3012
    }, {
      "text": "秦淮区",
      "value": 3013
    }, {
      "text": "鼓楼区",
      "value": 3015
    }, {
      "text": "栖霞区",
      "value": 3016
    }, {
      "text": "雨花台区",
      "value": 3017
    }, {
      "text": "六合区",
      "value": 3019
    }, {
      "text": "溧水区",
      "value": 3091
    }, {
      "text": "高淳区",
      "value": 3092
    }, {
      "text": "建邺区",
      "value": 3014
    }, {
      "text": "江宁区",
      "value": 3018
    }]
  }, {
    "text": "无锡市",
    "value": 1267,
    "children": [{
      "text": "滨湖区",
      "value": 3021
    }, {
      "text": "宜兴市",
      "value": 3023
    }, {
      "text": "梁溪区",
      "value": 3024
    }, {
      "text": "锡山区",
      "value": 3027
    }, {
      "text": "新吴区",
      "value": 3029
    }, {
      "text": "江阴市",
      "value": 3022
    }, {
      "text": "惠山区",
      "value": 3028
    }]
  }, {
    "text": "徐州市",
    "value": 1268,
    "children": [{
      "text": "丰　县",
      "value": 3031
    }, {
      "text": "沛　县",
      "value": 3032
    }, {
      "text": "睢宁县",
      "value": 3034
    }, {
      "text": "新沂市",
      "value": 3036
    }, {
      "text": "鼓楼区",
      "value": 3037
    }, {
      "text": "云龙区",
      "value": 3038
    }, {
      "text": "贾汪区",
      "value": 3211
    }, {
      "text": "泉山区",
      "value": 3212
    }, {
      "text": "邳州市",
      "value": 3035
    }, {
      "text": "铜山区",
      "value": 3039
    }]
  }, {
    "text": "常州市",
    "value": 1269,
    "children": [{
      "text": "武进区",
      "value": 3041
    }, {
      "text": "金坛区",
      "value": 3042
    }, {
      "text": "新北区",
      "value": 3044
    }, {
      "text": "天宁区",
      "value": 3045
    }, {
      "text": "钟楼区",
      "value": 3046
    }, {
      "text": "溧阳市",
      "value": 3043
    }]
  }, {
    "text": "苏州市",
    "value": 1270,
    "children": [{
      "text": "昆山市",
      "value": 3052
    }, {
      "text": "常熟市",
      "value": 3055
    }, {
      "text": "张家港市",
      "value": 3056
    }, {
      "text": "吴中区",
      "value": 3057
    }, {
      "text": "相城区",
      "value": 3059
    }, {
      "text": "姑苏区",
      "value": 3221
    }, {
      "text": "吴江区",
      "value": 3222
    }, {
      "text": "太仓市",
      "value": 3051
    }, {
      "text": "虎丘区",
      "value": 3058
    }]
  }, {
    "text": "南通市",
    "value": 1271,
    "children": [{
      "text": "如皋市",
      "value": 3062
    }, {
      "text": "如东县",
      "value": 3063
    }, {
      "text": "海门市",
      "value": 3065
    }, {
      "text": "启东市",
      "value": 3066
    }, {
      "text": "崇川区",
      "value": 3068
    }, {
      "text": "港闸区",
      "value": 3069
    }, {
      "text": "海安市",
      "value": 3061
    }, {
      "text": "通州区",
      "value": 3067
    }]
  }, {
    "text": "连云港市",
    "value": 1272,
    "children": [{
      "text": "赣榆区",
      "value": 3071
    }, {
      "text": "灌云县",
      "value": 3073
    }, {
      "text": "灌南县",
      "value": 3074
    }, {
      "text": "海州区",
      "value": 3076
    }, {
      "text": "东海县",
      "value": 3072
    }, {
      "text": "连云区",
      "value": 3075
    }]
  }, {
    "text": "淮安市",
    "value": 1273,
    "children": [{
      "text": "淮阴区",
      "value": 3081
    }, {
      "text": "清江浦区",
      "value": 3082
    }, {
      "text": "淮安区",
      "value": 3083
    }, {
      "text": "洪泽区",
      "value": 3087
    }, {
      "text": "盱眙县",
      "value": 3088
    }, {
      "text": "金湖县",
      "value": 3089
    }, {
      "text": "涟水县",
      "value": 3085
    }]
  }, {
    "text": "盐城市",
    "value": 1274,
    "children": [{
      "text": "响水县",
      "value": 3111
    }, {
      "text": "滨海县",
      "value": 3112
    }, {
      "text": "阜宁县",
      "value": 3113
    }, {
      "text": "射阳县",
      "value": 3114
    }, {
      "text": "建湖县",
      "value": 3115
    }, {
      "text": "大丰区",
      "value": 3116
    }, {
      "text": "东台市",
      "value": 3117
    }, {
      "text": "亭湖区",
      "value": 3118
    }, {
      "text": "盐都区",
      "value": 3119
    }]
  }, {
    "text": "扬州市",
    "value": 1275,
    "children": [{
      "text": "高邮市",
      "value": 3121
    }, {
      "text": "宝应县",
      "value": 3122
    }, {
      "text": "邗江区",
      "value": 3123
    }, {
      "text": "仪征市",
      "value": 3129
    }, {
      "text": "广陵区",
      "value": 3130
    }, {
      "text": "江都区",
      "value": 3131
    }]
  }, {
    "text": "镇江市",
    "value": 1276,
    "children": [{
      "text": "丹徒区",
      "value": 3141
    }, {
      "text": "句容市",
      "value": 3142
    }, {
      "text": "扬中市",
      "value": 3143
    }, {
      "text": "丹阳市",
      "value": 3144
    }, {
      "text": "润州区",
      "value": 3145
    }, {
      "text": "京口区",
      "value": 3146
    }]
  }, {
    "text": "泰州市",
    "value": 1277,
    "children": [{
      "text": "兴化市",
      "value": 3161
    }, {
      "text": "靖江市",
      "value": 3162
    }, {
      "text": "泰兴市",
      "value": 3163
    }, {
      "text": "姜堰区",
      "value": 3164
    }, {
      "text": "海陵区",
      "value": 3165
    }, {
      "text": "高港区",
      "value": 3166
    }]
  }, {
    "text": "宿迁市",
    "value": 1278,
    "children": [{
      "text": "沭阳县",
      "value": 3181
    }, {
      "text": "泗阳县",
      "value": 3182
    }, {
      "text": "泗洪县",
      "value": 3183
    }, {
      "text": "宿豫区",
      "value": 3184
    }, {
      "text": "宿城区",
      "value": 3185
    }]
  }]
}, {
  "text": "浙江省",
  "value": 24,
  "children": [{
    "text": "杭州市",
    "value": 1279,
    "children": [{
      "text": "桐庐县",
      "value": 3311
    }, {
      "text": "富阳区",
      "value": 3312
    }, {
      "text": "临安区",
      "value": 3313
    }, {
      "text": "建德市",
      "value": 3315
    }, {
      "text": "淳安县",
      "value": 3316
    }, {
      "text": "余杭区",
      "value": 3317
    }, {
      "text": "上城区",
      "value": 3318
    }, {
      "text": "下城区",
      "value": 3319
    }, {
      "text": "江干区",
      "value": 3471
    }, {
      "text": "拱墅区",
      "value": 3472
    }, {
      "text": "西湖区",
      "value": 3473
    }, {
      "text": "滨江区",
      "value": 3474
    }, {
      "text": "萧山区",
      "value": 3475
    }]
  }, {
    "text": "宁波市",
    "value": 1280,
    "children": [{
      "text": "象山县",
      "value": 3321
    }, {
      "text": "宁海县",
      "value": 3322
    }, {
      "text": "鄞州区",
      "value": 3323
    }, {
      "text": "余姚市",
      "value": 3324
    }, {
      "text": "慈溪市",
      "value": 3325
    }, {
      "text": "奉化区",
      "value": 3326
    }, {
      "text": "海曙区",
      "value": 3327
    }, {
      "text": "江北区",
      "value": 3329
    }, {
      "text": "北仑区",
      "value": 3481
    }, {
      "text": "镇海区",
      "value": 3482
    }]
  }, {
    "text": "温州市",
    "value": 1281,
    "children": [{
      "text": "洞头区",
      "value": 3332
    }, {
      "text": "乐清市",
      "value": 3333
    }, {
      "text": "永嘉县",
      "value": 3334
    }, {
      "text": "平阳县",
      "value": 3335
    }, {
      "text": "苍南县",
      "value": 3336
    }, {
      "text": "文成县",
      "value": 3337
    }, {
      "text": "泰顺县",
      "value": 3338
    }, {
      "text": "瑞安市",
      "value": 3339
    }, {
      "text": "鹿城区",
      "value": 3341
    }, {
      "text": "龙湾区",
      "value": 3342
    }, {
      "text": "瓯海区",
      "value": 3343
    }]
  }, {
    "text": "嘉兴市",
    "value": 1282,
    "children": [{
      "text": "嘉善县",
      "value": 3351
    }, {
      "text": "平湖市",
      "value": 3352
    }, {
      "text": "海盐县",
      "value": 3353
    }, {
      "text": "桐乡市",
      "value": 3354
    }, {
      "text": "海宁市",
      "value": 3355
    }, {
      "text": "秀洲区",
      "value": 3356
    }, {
      "text": "南湖区",
      "value": 3357
    }]
  }, {
    "text": "湖州市",
    "value": 1283,
    "children": [{
      "text": "德清县",
      "value": 3361
    }, {
      "text": "长兴县",
      "value": 3362
    }, {
      "text": "安吉县",
      "value": 3363
    }, {
      "text": "吴兴区",
      "value": 3364
    }, {
      "text": "南浔区",
      "value": 3365
    }]
  }, {
    "text": "金华市",
    "value": 1285,
    "children": [{
      "text": "婺城区",
      "value": 3381
    }, {
      "text": "永康市",
      "value": 3382
    }, {
      "text": "武义县",
      "value": 3383
    }, {
      "text": "浦江县",
      "value": 3384
    }, {
      "text": "磐安县",
      "value": 3385
    }, {
      "text": "兰溪市",
      "value": 3386
    }, {
      "text": "义乌市",
      "value": 3387
    }, {
      "text": "东阳市",
      "value": 3388
    }, {
      "text": "金东区",
      "value": 3389
    }]
  }, {
    "text": "衢州市",
    "value": 1286,
    "children": [{
      "text": "柯城区",
      "value": 3411
    }, {
      "text": "常山县",
      "value": 3412
    }, {
      "text": "开化县",
      "value": 3413
    }, {
      "text": "龙游县",
      "value": 3414
    }, {
      "text": "江山市",
      "value": 3415
    }, {
      "text": "衢江区",
      "value": 3416
    }]
  }, {
    "text": "舟山市",
    "value": 1287,
    "children": [{
      "text": "岱山县",
      "value": 3421
    }, {
      "text": "嵊泗县",
      "value": 3422
    }, {
      "text": "定海区",
      "value": 3423
    }, {
      "text": "普陀区",
      "value": 3424
    }]
  }, {
    "text": "丽水市",
    "value": 1288,
    "children": [{
      "text": "莲都区",
      "value": 3431
    }, {
      "text": "青田县",
      "value": 3432
    }, {
      "text": "云和县",
      "value": 3433
    }, {
      "text": "庆元县",
      "value": 3434
    }, {
      "text": "缙云县",
      "value": 3435
    }, {
      "text": "遂昌县",
      "value": 3436
    }, {
      "text": "松阳县",
      "value": 3437
    }, {
      "text": "景宁畲族自治县",
      "value": 3438
    }, {
      "text": "龙泉市",
      "value": 3439
    }]
  }, {
    "text": "绍兴市",
    "value": 1284,
    "children": [{
      "text": "柯桥区",
      "value": 3371
    }, {
      "text": "越城区",
      "value": 3372
    }, {
      "text": "嵊州市",
      "value": 3373
    }, {
      "text": "新昌县",
      "value": 3374
    }, {
      "text": "诸暨市",
      "value": 3375
    }, {
      "text": "上虞区",
      "value": 3376
    }]
  }, {
    "text": "台州市",
    "value": 1289,
    "children": [{
      "text": "椒江区",
      "value": 3451
    }, {
      "text": "临海市",
      "value": 3452
    }, {
      "text": "路桥区",
      "value": 3453
    }, {
      "text": "温岭市",
      "value": 3454
    }, {
      "text": "仙居县",
      "value": 3455
    }, {
      "text": "天台县",
      "value": 3456
    }, {
      "text": "三门县",
      "value": 3457
    }, {
      "text": "玉环市",
      "value": 3458
    }, {
      "text": "黄岩区",
      "value": 3459
    }]
  }]
}, {
  "text": "安徽省",
  "value": 25,
  "children": [{
    "text": "合肥市",
    "value": 1290,
    "children": [{
      "text": "长丰县",
      "value": 3611
    }, {
      "text": "肥东县",
      "value": 3612
    }, {
      "text": "肥西县",
      "value": 3613
    }, {
      "text": "庐江县",
      "value": 3614
    }, {
      "text": "巢湖市（直辖）",
      "value": 3615
    }, {
      "text": "瑶海区",
      "value": 3616
    }, {
      "text": "庐阳区",
      "value": 3617
    }, {
      "text": "蜀山区",
      "value": 3618
    }, {
      "text": "包河区",
      "value": 3619
    }]
  }, {
    "text": "芜湖市",
    "value": 1291,
    "children": [{
      "text": "芜湖县",
      "value": 3621
    }, {
      "text": "繁昌县",
      "value": 3622
    }, {
      "text": "无为县",
      "value": 3624
    }, {
      "text": "镜湖区",
      "value": 3625
    }, {
      "text": "弋江区",
      "value": 3626
    }, {
      "text": "鸠江区",
      "value": 3627
    }, {
      "text": "南陵县",
      "value": 3623
    }, {
      "text": "三山区",
      "value": 3628
    }]
  }, {
    "text": "蚌埠市",
    "value": 1292,
    "children": [{
      "text": "怀远县",
      "value": 3631
    }, {
      "text": "五河县",
      "value": 3632
    }, {
      "text": "固镇县",
      "value": 3633
    }, {
      "text": "蚌山区",
      "value": 3635
    }, {
      "text": "禹会区",
      "value": 3636
    }, {
      "text": "淮上区",
      "value": 3637
    }, {
      "text": "龙子湖区",
      "value": 3634
    }]
  }, {
    "text": "马鞍山市",
    "value": 1294,
    "children": [{
      "text": "当涂县",
      "value": 3651
    }, {
      "text": "含山县",
      "value": 3652
    }, {
      "text": "花山区",
      "value": 3654
    }, {
      "text": "雨山区",
      "value": 3655
    }, {
      "text": "博望区",
      "value": 3656
    }, {
      "text": "和　县",
      "value": 3653
    }]
  }, {
    "text": "淮北市",
    "value": 1295,
    "children": [{
      "text": "杜集区",
      "value": 3662
    }, {
      "text": "相山区",
      "value": 3663
    }, {
      "text": "烈山区",
      "value": 3664
    }, {
      "text": "濉溪县",
      "value": 3661
    }]
  }, {
    "text": "铜陵市",
    "value": 1296,
    "children": [{
      "text": "义安区",
      "value": 3671
    }, {
      "text": "郊  区",
      "value": 3674
    }, {
      "text": "枞阳县",
      "value": 3683
    }, {
      "text": "铜官区",
      "value": 3672
    }]
  }, {
    "text": "黄山市",
    "value": 1298,
    "children": [{
      "text": "休宁县",
      "value": 3712
    }, {
      "text": "黟  县",
      "value": 3713
    }, {
      "text": "祁门县",
      "value": 3714
    }, {
      "text": "屯溪区",
      "value": 3715
    }, {
      "text": "徽州区",
      "value": 3717
    }, {
      "text": "歙  县",
      "value": 3711
    }, {
      "text": "黄山区",
      "value": 3716
    }]
  }, {
    "text": "阜阳市",
    "value": 1299,
    "children": [{
      "text": "颍州区",
      "value": 3721
    }, {
      "text": "颍东区",
      "value": 3722
    }, {
      "text": "临泉县",
      "value": 3724
    }, {
      "text": "太和县",
      "value": 3725
    }, {
      "text": "阜南县",
      "value": 3728
    }, {
      "text": "颍上县",
      "value": 3729
    }, {
      "text": "颍泉区",
      "value": 3723
    }, {
      "text": "界首市",
      "value": 3731
    }]
  }, {
    "text": "滁州市",
    "value": 1301,
    "children": [{
      "text": "南谯区",
      "value": 3751
    }, {
      "text": "天长市",
      "value": 3752
    }, {
      "text": "全椒县",
      "value": 3754
    }, {
      "text": "定远县",
      "value": 3755
    }, {
      "text": "凤阳县",
      "value": 3756
    }, {
      "text": "明光市",
      "value": 3757
    }, {
      "text": "来安县",
      "value": 3753
    }, {
      "text": "琅琊区",
      "value": 3758
    }]
  }, {
    "text": "六安市",
    "value": 1302,
    "children": [{
      "text": "金安区",
      "value": 3761
    }, {
      "text": "裕安区",
      "value": 3762
    }, {
      "text": "霍邱县",
      "value": 3764
    }, {
      "text": "金寨县",
      "value": 3766
    }, {
      "text": "霍山县",
      "value": 3767
    }, {
      "text": "舒城县",
      "value": 3765
    }]
  }, {
    "text": "宣城市",
    "value": 1303,
    "children": [{
      "text": "郎溪县",
      "value": 3772
    }, {
      "text": "广德县淮南市",
      "value": 3773
    }, {
      "text": "泾　县",
      "value": 3775
    }, {
      "text": "旌德县",
      "value": 3776
    }, {
      "text": "绩溪县",
      "value": 3777
    }, {
      "text": "宁国市",
      "value": 3774
    }, {
      "text": "宣州区",
      "value": 3778
    }]
  }, {
    "text": "亳州市",
    "value": 1305,
    "children": [{
      "text": "蒙城县",
      "value": 3812
    }, {
      "text": "利辛县",
      "value": 3813
    }, {
      "text": "谯城区",
      "value": 3815
    }, {
      "text": "涡阳县",
      "value": 3811
    }]
  }, {
    "text": "淮南市",
    "value": 1293,
    "children": [{
      "text": "凤台县",
      "value": 3641
    }, {
      "text": "田家庵区",
      "value": 3643
    }, {
      "text": "谢家集区",
      "value": 3644
    }, {
      "text": "八公山区",
      "value": 3645
    }, {
      "text": "潘集区",
      "value": 3646
    }, {
      "text": "大通区",
      "value": 3642
    }, {
      "text": "寿　县",
      "value": 3763
    }]
  }, {
    "text": "安庆市",
    "value": 1297,
    "children": [{
      "text": "桐城市",
      "value": 3681
    }, {
      "text": "潜山市",
      "value": 3684
    }, {
      "text": "太湖县",
      "value": 3685
    }, {
      "text": "宿松县",
      "value": 3686
    }, {
      "text": "望江县",
      "value": 3687
    }, {
      "text": "迎江区",
      "value": 3689
    }, {
      "text": "大观区",
      "value": 3691
    }, {
      "text": "宜秀区",
      "value": 3692
    }, {
      "text": "怀宁县",
      "value": 3682
    }, {
      "text": "岳西县",
      "value": 3688
    }]
  }, {
    "text": "宿州市",
    "value": 1300,
    "children": [{
      "text": "埇桥区",
      "value": 3741
    }, {
      "text": "砀山县",
      "value": 3742
    }, {
      "text": "萧  县",
      "value": 3743
    }, {
      "text": "泗  县",
      "value": 3746
    }, {
      "text": "灵璧县",
      "value": 3745
    }]
  }, {
    "text": "池州市",
    "value": 1304,
    "children": [{
      "text": "贵池区",
      "value": 3791
    }, {
      "text": "东至县",
      "value": 3792
    }, {
      "text": "石台县",
      "value": 3793
    }, {
      "text": "青阳县",
      "value": 3794
    }]
  }]
}, {
  "text": "福建省",
  "value": 26,
  "children": [{
    "text": "福州市",
    "value": 1306,
    "children": [{
      "text": "闽侯县",
      "value": 3911
    }, {
      "text": "连江县",
      "value": 3912
    }, {
      "text": "罗源县",
      "value": 3913
    }, {
      "text": "闽清县",
      "value": 3914
    }, {
      "text": "永泰县",
      "value": 3915
    }, {
      "text": "长乐区",
      "value": 3916
    }, {
      "text": "福清市",
      "value": 3917
    }, {
      "text": "平潭县",
      "value": 3918
    }, {
      "text": "鼓楼区",
      "value": 3919
    }, {
      "text": "台江区",
      "value": 3921
    }, {
      "text": "仓山区",
      "value": 3922
    }, {
      "text": "马尾区",
      "value": 3923
    }, {
      "text": "晋安区",
      "value": 3924
    }]
  }, {
    "text": "厦门市",
    "value": 1307,
    "children": [{
      "text": "思明区",
      "value": 3931
    }, {
      "text": "海沧区",
      "value": 3932
    }, {
      "text": "湖里区",
      "value": 3933
    }, {
      "text": "集美区",
      "value": 3934
    }, {
      "text": "同安区",
      "value": 3935
    }, {
      "text": "翔安区",
      "value": 3936
    }]
  }, {
    "text": "三明市",
    "value": 1309,
    "children": [{
      "text": "明溪县",
      "value": 3951
    }, {
      "text": "清流县",
      "value": 3952
    }, {
      "text": "宁化县",
      "value": 3953
    }, {
      "text": "大田县",
      "value": 3954
    }, {
      "text": "尤溪县",
      "value": 3955
    }, {
      "text": "沙　县",
      "value": 3956
    }, {
      "text": "将乐县",
      "value": 3957
    }, {
      "text": "泰宁县",
      "value": 3958
    }, {
      "text": "建宁县",
      "value": 3959
    }, {
      "text": "永安市",
      "value": 3961
    }, {
      "text": "梅列区",
      "value": 3962
    }, {
      "text": "三元区",
      "value": 3963
    }]
  }, {
    "text": "泉州市",
    "value": 1310,
    "children": [{
      "text": "惠安县",
      "value": 3971
    }, {
      "text": "晋江市",
      "value": 3972
    }, {
      "text": "南安市",
      "value": 3973
    }, {
      "text": "安溪县",
      "value": 3974
    }, {
      "text": "永春县",
      "value": 3975
    }, {
      "text": "德化县",
      "value": 3976
    }, {
      "text": "金门县",
      "value": 3977
    }, {
      "text": "石狮市",
      "value": 3978
    }, {
      "text": "鲤城区",
      "value": 3981
    }, {
      "text": "丰泽区",
      "value": 3982
    }, {
      "text": "洛江区",
      "value": 3983
    }, {
      "text": "泉港区",
      "value": 3984
    }]
  }, {
    "text": "漳州市",
    "value": 1311,
    "children": [{
      "text": "龙海市",
      "value": 3991
    }, {
      "text": "云霄县",
      "value": 3992
    }, {
      "text": "漳浦县",
      "value": 3993
    }, {
      "text": "诏安县",
      "value": 3994
    }, {
      "text": "长泰县",
      "value": 3995
    }, {
      "text": "东山县",
      "value": 3996
    }, {
      "text": "南靖县",
      "value": 3997
    }, {
      "text": "平和县",
      "value": 3998
    }, {
      "text": "华安县",
      "value": 3999
    }, {
      "text": "芗城区",
      "value": 4061
    }, {
      "text": "龙文区",
      "value": 4062
    }]
  }, {
    "text": "宁德市",
    "value": 1313,
    "children": [{
      "text": "蕉城区",
      "value": 4031
    }, {
      "text": "福鼎市",
      "value": 4032
    }, {
      "text": "霞浦县",
      "value": 4033
    }, {
      "text": "福安市",
      "value": 4034
    }, {
      "text": "古田县",
      "value": 4035
    }, {
      "text": "屏南县",
      "value": 4036
    }, {
      "text": "寿宁县",
      "value": 4037
    }, {
      "text": "周宁县",
      "value": 4038
    }, {
      "text": "柘荣县",
      "value": 4039
    }]
  }, {
    "text": "龙岩市",
    "value": 1314,
    "children": [{
      "text": "新罗区",
      "value": 4051
    }, {
      "text": "长汀县",
      "value": 4052
    }, {
      "text": "永定区",
      "value": 4053
    }, {
      "text": "上杭县",
      "value": 4054
    }, {
      "text": "武平县",
      "value": 4055
    }, {
      "text": "漳平市",
      "value": 4056
    }, {
      "text": "连城县",
      "value": 4057
    }]
  }, {
    "text": "莆田市",
    "value": 1308,
    "children": [{
      "text": "城厢区",
      "value": 3941
    }, {
      "text": "仙游县",
      "value": 3942
    }, {
      "text": "涵江区",
      "value": 3943
    }, {
      "text": "荔城区",
      "value": 3944
    }, {
      "text": "秀屿区",
      "value": 3945
    }]
  }, {
    "text": "南平市",
    "value": 1312,
    "children": [{
      "text": "延平区",
      "value": 4011
    }, {
      "text": "邵武市",
      "value": 4012
    }, {
      "text": "顺昌县",
      "value": 4013
    }, {
      "text": "建阳区",
      "value": 4014
    }, {
      "text": "建瓯市",
      "value": 4015
    }, {
      "text": "浦城县",
      "value": 4016
    }, {
      "text": "武夷山市",
      "value": 4017
    }, {
      "text": "光泽县",
      "value": 4018
    }, {
      "text": "松溪县",
      "value": 4019
    }, {
      "text": "政和县",
      "value": 4021
    }]
  }]
}, {
  "text": "江西省",
  "value": 27,
  "children": [{
    "text": "南昌市",
    "value": 1315,
    "children": [{
      "text": "南昌县",
      "value": 4211
    }, {
      "text": "新建区",
      "value": 4212
    }, {
      "text": "安义县",
      "value": 4213
    }, {
      "text": "进贤县",
      "value": 4214
    }, {
      "text": "青山湖区",
      "value": 4215
    }, {
      "text": "东湖区",
      "value": 4216
    }, {
      "text": "西湖区",
      "value": 4217
    }, {
      "text": "青云谱区",
      "value": 4218
    }, {
      "text": "湾里区",
      "value": 4219
    }, {
      "text": "赣江新区",
      "value": 4391
    }]
  }, {
    "text": "萍乡市",
    "value": 1317,
    "children": [{
      "text": "莲花县",
      "value": 4231
    }, {
      "text": "上栗县",
      "value": 4232
    }, {
      "text": "芦溪县",
      "value": 4233
    }, {
      "text": "安源区",
      "value": 4234
    }, {
      "text": "湘东区",
      "value": 4235
    }]
  }, {
    "text": "九江市",
    "value": 1318,
    "children": [{
      "text": "柴桑区",
      "value": 4241
    }, {
      "text": "瑞昌市",
      "value": 4242
    }, {
      "text": "武宁县",
      "value": 4243
    }, {
      "text": "修水县",
      "value": 4244
    }, {
      "text": "永修县",
      "value": 4245
    }, {
      "text": "德安县",
      "value": 4246
    }, {
      "text": "庐山市",
      "value": 4247
    }, {
      "text": "都昌县",
      "value": 4248
    }, {
      "text": "湖口县",
      "value": 4249
    }, {
      "text": "彭泽县",
      "value": 4251
    }, {
      "text": "共青城市",
      "value": 4252
    }, {
      "text": "濂溪区",
      "value": 4253
    }, {
      "text": "浔阳区",
      "value": 4254
    }]
  }, {
    "text": "新余市",
    "value": 1319,
    "children": [{
      "text": "分宜县",
      "value": 4261
    }, {
      "text": "渝水区",
      "value": 4262
    }]
  }, {
    "text": "赣州市",
    "value": 1321,
    "children": [{
      "text": "章贡区",
      "value": 4281
    }, {
      "text": "赣县区",
      "value": 4282
    }, {
      "text": "南康区",
      "value": 4283
    }, {
      "text": "信丰县",
      "value": 4284
    }, {
      "text": "大余县",
      "value": 4285
    }, {
      "text": "上犹县",
      "value": 4286
    }, {
      "text": "崇义县",
      "value": 4287
    }, {
      "text": "安远县",
      "value": 4288
    }, {
      "text": "龙南县",
      "value": 4289
    }, {
      "text": "定南县",
      "value": 4291
    }, {
      "text": "全南县",
      "value": 4292
    }, {
      "text": "宁都县",
      "value": 4293
    }, {
      "text": "于都县",
      "value": 4294
    }, {
      "text": "瑞金市",
      "value": 4296
    }, {
      "text": "会昌县",
      "value": 4297
    }, {
      "text": "寻乌县",
      "value": 4298
    }, {
      "text": "石城县",
      "value": 4299
    }, {
      "text": "兴国县",
      "value": 4295
    }]
  }, {
    "text": "宜春市",
    "value": 1322,
    "children": [{
      "text": "丰城市",
      "value": 4312
    }, {
      "text": "樟树市",
      "value": 4313
    }, {
      "text": "高安市",
      "value": 4314
    }, {
      "text": "万载县",
      "value": 4316
    }, {
      "text": "上高县",
      "value": 4317
    }, {
      "text": "宜丰县",
      "value": 4318
    }, {
      "text": "靖安县",
      "value": 4319
    }, {
      "text": "袁州区",
      "value": 4311
    }, {
      "text": "奉新县",
      "value": 4315
    }, {
      "text": "铜鼓县",
      "value": 4321
    }]
  }, {
    "text": "上饶市",
    "value": 1323,
    "children": [{
      "text": "信州区",
      "value": 4331
    }, {
      "text": "上饶县",
      "value": 4332
    }, {
      "text": "广丰县",
      "value": 4333
    }, {
      "text": "铅山县",
      "value": 4335
    }, {
      "text": "横峰县",
      "value": 4336
    }, {
      "text": "弋阳县",
      "value": 4337
    }, {
      "text": "余干县",
      "value": 4338
    }, {
      "text": "万年县",
      "value": 4341
    }, {
      "text": "德兴市",
      "value": 4342
    }, {
      "text": "婺源县",
      "value": 4343
    }, {
      "text": "玉山县",
      "value": 4334
    }, {
      "text": "鄱阳县",
      "value": 4339
    }]
  }, {
    "text": "抚州市",
    "value": 1325,
    "children": [{
      "text": "南城县",
      "value": 4372
    }, {
      "text": "南丰县",
      "value": 4374
    }, {
      "text": "崇仁县",
      "value": 4375
    }, {
      "text": "乐安县",
      "value": 4376
    }, {
      "text": "金溪县",
      "value": 4378
    }, {
      "text": "资溪县",
      "value": 4379
    }, {
      "text": "东乡区",
      "value": 4381
    }, {
      "text": "广昌县",
      "value": 4382
    }, {
      "text": "黎川县",
      "value": 4373
    }, {
      "text": "宜黄县",
      "value": 4377
    }, {
      "text": "临川区",
      "value": 4383
    }]
  }, {
    "text": "景德镇市",
    "value": 1316,
    "children": [{
      "text": "乐平市",
      "value": 4221
    }, {
      "text": "浮梁县",
      "value": 4222
    }, {
      "text": "昌江区",
      "value": 4223
    }, {
      "text": "珠山区",
      "value": 4224
    }]
  }, {
    "text": "鹰潭市",
    "value": 1320,
    "children": [{
      "text": "贵溪市",
      "value": 4271
    }, {
      "text": "余江区",
      "value": 4272
    }, {
      "text": "月湖区",
      "value": 4273
    }]
  }, {
    "text": "吉安市",
    "value": 1324,
    "children": [{
      "text": "井冈山市",
      "value": 4352
    }, {
      "text": "吉安县",
      "value": 4353
    }, {
      "text": "吉水县",
      "value": 4354
    }, {
      "text": "峡江县",
      "value": 4355
    }, {
      "text": "永丰县",
      "value": 4357
    }, {
      "text": "泰和县",
      "value": 4358
    }, {
      "text": "遂川县",
      "value": 4359
    }, {
      "text": "安福县",
      "value": 4362
    }, {
      "text": "永新县",
      "value": 4363
    }, {
      "text": "吉州区",
      "value": 4364
    }, {
      "text": "青原区",
      "value": 4351
    }, {
      "text": "新干县",
      "value": 4356
    }, {
      "text": "万安县",
      "value": 4361
    }]
  }]
}, {
  "text": "山东省",
  "value": 28,
  "children": [{
    "text": "济南市",
    "value": 1326,
    "children": [{
      "text": "章丘区",
      "value": 4511
    }, {
      "text": "历城区",
      "value": 4512
    }, {
      "text": "平阴县",
      "value": 4513
    }, {
      "text": "商河县",
      "value": 4515
    }, {
      "text": "历下区",
      "value": 4516
    }, {
      "text": "市中区",
      "value": 4517
    }, {
      "text": "槐荫区",
      "value": 4518
    }, {
      "text": "长清区",
      "value": 4641
    }, {
      "text": "济阳区",
      "value": 4514
    }, {
      "text": "天桥区",
      "value": 4519
    }]
  }, {
    "text": "青岛市",
    "value": 1327,
    "children": [{
      "text": "即墨区",
      "value": 4521
    }, {
      "text": "市北区",
      "value": 4522
    }, {
      "text": "平度市",
      "value": 4524
    }, {
      "text": "胶州市",
      "value": 4525
    }, {
      "text": "崂山区",
      "value": 4526
    }, {
      "text": "西海岸新区（含黄岛区全部区域）",
      "value": 4527
    }, {
      "text": "李沧区",
      "value": 4529
    }, {
      "text": "城阳区",
      "value": 4671
    }, {
      "text": "莱西市",
      "value": 4523
    }, {
      "text": "市南区",
      "value": 4528
    }]
  }, {
    "text": "枣庄市",
    "value": 1329,
    "children": [{
      "text": "滕州市",
      "value": 4541
    }, {
      "text": "市中区",
      "value": 4542
    }, {
      "text": "峄城区",
      "value": 4544
    }, {
      "text": "台儿庄区",
      "value": 4545
    }, {
      "text": "山亭区",
      "value": 4546
    }, {
      "text": "薛城区",
      "value": 4543
    }]
  }, {
    "text": "东营市",
    "value": 1330,
    "children": [{
      "text": "垦利区",
      "value": 4551
    }, {
      "text": "广饶县",
      "value": 4553
    }, {
      "text": "利津县",
      "value": 4552
    }, {
      "text": "河口区",
      "value": 4554
    }, {
      "text": "东营区",
      "value": 4555
    }]
  }, {
    "text": "潍坊市",
    "value": 1332,
    "children": [{
      "text": "安丘市",
      "value": 4581
    }, {
      "text": "寿光市",
      "value": 4582
    }, {
      "text": "临朐县",
      "value": 4583
    }, {
      "text": "昌乐县",
      "value": 4584
    }, {
      "text": "昌邑市",
      "value": 4585
    }, {
      "text": "高密市",
      "value": 4586
    }, {
      "text": "青州市",
      "value": 4588
    }, {
      "text": "诸城市",
      "value": 4589
    }, {
      "text": "奎文区",
      "value": 4590
    }, {
      "text": "潍城区",
      "value": 4591
    }, {
      "text": "寒亭区",
      "value": 4592
    }, {
      "text": "坊子区",
      "value": 4593
    }]
  }, {
    "text": "济宁市",
    "value": 1333,
    "children": [{
      "text": "任城区",
      "value": 4611
    }, {
      "text": "邹城市",
      "value": 4612
    }, {
      "text": "微山县",
      "value": 4613
    }, {
      "text": "鱼台县",
      "value": 4614
    }, {
      "text": "金乡县",
      "value": 4615
    }, {
      "text": "嘉祥县",
      "value": 4616
    }, {
      "text": "汶上县",
      "value": 4617
    }, {
      "text": "泗水县",
      "value": 4618
    }, {
      "text": "曲阜市",
      "value": 4619
    }, {
      "text": "梁山县",
      "value": 4621
    }, {
      "text": "兖州区",
      "value": 4622
    }]
  }, {
    "text": "泰安市",
    "value": 1334,
    "children": [{
      "text": "宁阳县",
      "value": 4631
    }, {
      "text": "肥城市",
      "value": 4632
    }, {
      "text": "东平县",
      "value": 4633
    }, {
      "text": "新泰市",
      "value": 4635
    }, {
      "text": "泰山区",
      "value": 4636
    }, {
      "text": "岱岳区",
      "value": 4637
    }]
  }, {
    "text": "滨州市",
    "value": 1336,
    "children": [{
      "text": "惠民县",
      "value": 4662
    }, {
      "text": "阳信县",
      "value": 4663
    }, {
      "text": "无棣县",
      "value": 4664
    }, {
      "text": "沾化区",
      "value": 4665
    }, {
      "text": "博兴县",
      "value": 4666
    }, {
      "text": "邹平市",
      "value": 4667
    }, {
      "text": "滨城区",
      "value": 4668
    }]
  }, {
    "text": "德州市",
    "value": 1337,
    "children": [{
      "text": "德城区",
      "value": 4681
    }, {
      "text": "乐陵市",
      "value": 4682
    }, {
      "text": "陵城区",
      "value": 4683
    }, {
      "text": "平原县",
      "value": 4684
    }, {
      "text": "夏津县",
      "value": 4685
    }, {
      "text": "武城县",
      "value": 4686
    }, {
      "text": "齐河县",
      "value": 4687
    }, {
      "text": "禹城市",
      "value": 4688
    }, {
      "text": "临邑县",
      "value": 4689
    }, {
      "text": "宁津县",
      "value": 4693
    }, {
      "text": "庆云县",
      "value": 4694
    }]
  }, {
    "text": "聊城市",
    "value": 1338,
    "children": [{
      "text": "东昌府区",
      "value": 4711
    }, {
      "text": "临清市",
      "value": 4712
    }, {
      "text": "阳谷县",
      "value": 4713
    }, {
      "text": "莘  县",
      "value": 4714
    }, {
      "text": "茌平县",
      "value": 4715
    }, {
      "text": "东阿县",
      "value": 4716
    }, {
      "text": "冠  县",
      "value": 4717
    }, {
      "text": "高唐县",
      "value": 4718
    }]
  }, {
    "text": "菏泽市",
    "value": 1340,
    "children": [{
      "text": "牡丹区",
      "value": 4751
    }, {
      "text": "曹  县",
      "value": 4752
    }, {
      "text": "定陶区",
      "value": 4753
    }, {
      "text": "成武县",
      "value": 4754
    }, {
      "text": "单  县",
      "value": 4755
    }, {
      "text": "巨野县",
      "value": 4756
    }, {
      "text": "郓城县",
      "value": 4758
    }, {
      "text": "鄄城县",
      "value": 4759
    }, {
      "text": "东明县",
      "value": 4761
    }]
  }, {
    "text": "日照市",
    "value": 1341,
    "children": [{
      "text": "五莲县",
      "value": 4771
    }, {
      "text": "莒  县",
      "value": 4772
    }, {
      "text": "东港区",
      "value": 4773
    }, {
      "text": "岚山区",
      "value": 4774
    }]
  }, {
    "text": "莱芜市",
    "value": 1342,
    "children": [{
      "text": "钢城区",
      "value": 4791
    }, {
      "text": "莱城区",
      "value": 4792
    }]
  }, {
    "text": "淄博市",
    "value": 1328,
    "children": [{
      "text": "桓台县",
      "value": 4531
    }, {
      "text": "沂源县",
      "value": 4533
    }, {
      "text": "淄川区",
      "value": 4534
    }, {
      "text": "张店区",
      "value": 4535
    }, {
      "text": "博山区",
      "value": 4536
    }, {
      "text": "周村区",
      "value": 4538
    }, {
      "text": "高青县",
      "value": 4532
    }, {
      "text": "临淄区",
      "value": 4537
    }]
  }, {
    "text": "烟台市",
    "value": 1331,
    "children": [{
      "text": "蓬莱市",
      "value": 4561
    }, {
      "text": "招远市",
      "value": 4562
    }, {
      "text": "栖霞市",
      "value": 4563
    }, {
      "text": "海阳市",
      "value": 4564
    }, {
      "text": "长岛县",
      "value": 4566
    }, {
      "text": "龙口市",
      "value": 4567
    }, {
      "text": "莱阳市",
      "value": 4568
    }, {
      "text": "莱州市",
      "value": 4569
    }, {
      "text": "牟平区",
      "value": 4571
    }, {
      "text": "芝罘区",
      "value": 4572
    }, {
      "text": "福山区",
      "value": 4573
    }, {
      "text": "莱山区",
      "value": 4574
    }]
  }, {
    "text": "威海市",
    "value": 1335,
    "children": [{
      "text": "乳山市",
      "value": 4651
    }, {
      "text": "文登区",
      "value": 4652
    }, {
      "text": "荣成市",
      "value": 4653
    }, {
      "text": "环翠区",
      "value": 4654
    }]
  }, {
    "text": "临沂市",
    "value": 1339,
    "children": [{
      "text": "兰山区",
      "value": 4731
    }, {
      "text": "罗庄区",
      "value": 4732
    }, {
      "text": "郯城县",
      "value": 4733
    }, {
      "text": "兰陵县",
      "value": 4734
    }, {
      "text": "莒南县",
      "value": 4735
    }, {
      "text": "河东区",
      "value": 4736
    }, {
      "text": "沂水县",
      "value": 4737
    }, {
      "text": "蒙阴县",
      "value": 4739
    }, {
      "text": "平邑县",
      "value": 4741
    }, {
      "text": "费  县",
      "value": 4742
    }, {
      "text": "沂南县",
      "value": 4743
    }, {
      "text": "临沭县",
      "value": 4744
    }]
  }]
}, {
  "text": "河南省",
  "value": 29,
  "children": [{
    "text": "开封市",
    "value": 1344,
    "children": [{
      "text": "杞  县",
      "value": 4921
    }, {
      "text": "通许县",
      "value": 4922
    }, {
      "text": "尉氏县",
      "value": 4923
    }, {
      "text": "祥符区",
      "value": 4924
    }, {
      "text": "兰考县",
      "value": 4925
    }, {
      "text": "龙亭区",
      "value": 4926
    }, {
      "text": "顺河回族区",
      "value": 4927
    }, {
      "text": "鼓楼区",
      "value": 4928
    }, {
      "text": "禹王台区",
      "value": 4929
    }]
  }, {
    "text": "洛阳市",
    "value": 1345,
    "children": [{
      "text": "偃师市",
      "value": 4931
    }, {
      "text": "孟津县",
      "value": 4932
    }, {
      "text": "新安县",
      "value": 4933
    }, {
      "text": "栾川县",
      "value": 4934
    }, {
      "text": "嵩  县",
      "value": 4935
    }, {
      "text": "汝阳县",
      "value": 4936
    }, {
      "text": "宜阳县",
      "value": 4937
    }, {
      "text": "洛宁县",
      "value": 4938
    }, {
      "text": "伊川县",
      "value": 4939
    }, {
      "text": "老城区",
      "value": 4941
    }, {
      "text": "西工区",
      "value": 4942
    }, {
      "text": "瀍河回族区",
      "value": 4943
    }, {
      "text": "涧西区",
      "value": 4944
    }, {
      "text": "吉利区",
      "value": 4945
    }, {
      "text": "洛龙区",
      "value": 4946
    }]
  }, {
    "text": "平顶山市",
    "value": 1346,
    "children": [{
      "text": "宝丰县",
      "value": 4951
    }, {
      "text": "叶  县",
      "value": 4952
    }, {
      "text": "鲁山县",
      "value": 4953
    }, {
      "text": "汝州市",
      "value": 4956
    }, {
      "text": "舞钢市",
      "value": 4957
    }, {
      "text": "卫东区",
      "value": 4959
    }, {
      "text": "石龙区",
      "value": 5171
    }, {
      "text": "湛河区",
      "value": 5172
    }, {
      "text": "郏  县",
      "value": 4954
    }, {
      "text": "新华区",
      "value": 4958
    }]
  }, {
    "text": "鹤壁市",
    "value": 1348,
    "children": [{
      "text": "淇  县",
      "value": 4972
    }, {
      "text": "鹤山区",
      "value": 4973
    }, {
      "text": "山城区",
      "value": 4974
    }, {
      "text": "淇滨区",
      "value": 4975
    }, {
      "text": "浚  县",
      "value": 4971
    }]
  }, {
    "text": "新乡市",
    "value": 1349,
    "children": [{
      "text": "获嘉县",
      "value": 4982
    }, {
      "text": "原阳县",
      "value": 4983
    }, {
      "text": "延津县",
      "value": 4984
    }, {
      "text": "长垣县",
      "value": 4986
    }, {
      "text": "卫辉市",
      "value": 4987
    }, {
      "text": "辉县市",
      "value": 4988
    }, {
      "text": "红旗区",
      "value": 4989
    }, {
      "text": "凤泉区",
      "value": 4992
    }, {
      "text": "牧野区",
      "value": 4993
    }, {
      "text": "新乡县",
      "value": 4981
    }, {
      "text": "封丘县",
      "value": 4985
    }, {
      "text": "卫滨区",
      "value": 4991
    }]
  }, {
    "text": "濮阳市",
    "value": 1351,
    "children": [{
      "text": "清丰县",
      "value": 5021
    }, {
      "text": "范  县",
      "value": 5023
    }, {
      "text": "台前县",
      "value": 5024
    }, {
      "text": "濮阳县",
      "value": 5025
    }, {
      "text": "南乐县",
      "value": 5022
    }, {
      "text": "华龙区",
      "value": 5026
    }]
  }, {
    "text": "许昌市",
    "value": 1352,
    "children": [{
      "text": "长葛市",
      "value": 5031
    }, {
      "text": "建安区",
      "value": 5032
    }, {
      "text": "鄢陵县",
      "value": 5033
    }, {
      "text": "禹州市",
      "value": 5034
    }, {
      "text": "魏都区",
      "value": 5036
    }, {
      "text": "襄城县",
      "value": 5035
    }]
  }, {
    "text": "漯河市",
    "value": 1353,
    "children": [{
      "text": "舞阳县",
      "value": 5041
    }, {
      "text": "临颍县",
      "value": 5042
    }, {
      "text": "郾城区",
      "value": 5044
    }, {
      "text": "召陵区",
      "value": 5045
    }, {
      "text": "源汇区",
      "value": 5043
    }]
  }, {
    "text": "商丘市",
    "value": 1355,
    "children": [{
      "text": "梁园区",
      "value": 5061
    }, {
      "text": "虞城县",
      "value": 5062
    }, {
      "text": "睢阳区",
      "value": 5063
    }, {
      "text": "宁陵县",
      "value": 5065
    }, {
      "text": "睢  县",
      "value": 5066
    }, {
      "text": "夏邑县",
      "value": 5067
    }, {
      "text": "柘城县",
      "value": 5068
    }, {
      "text": "民权县",
      "value": 5064
    }, {
      "text": "永城市",
      "value": 5069
    }]
  }, {
    "text": "周口市",
    "value": 1356,
    "children": [{
      "text": "川汇区",
      "value": 5081
    }, {
      "text": "扶沟县",
      "value": 5082
    }, {
      "text": "西华县",
      "value": 5083
    }, {
      "text": "太康县",
      "value": 5085
    }, {
      "text": "鹿邑县",
      "value": 5086
    }, {
      "text": "郸城县",
      "value": 5087
    }, {
      "text": "淮阳县",
      "value": 5088
    }, {
      "text": "项城市",
      "value": 5091
    }, {
      "text": "商水县",
      "value": 5084
    }, {
      "text": "沈丘县",
      "value": 5089
    }]
  }, {
    "text": "驻马店市",
    "value": 1357,
    "children": [{
      "text": "驿城区",
      "value": 5111
    }, {
      "text": "确山县",
      "value": 5112
    }, {
      "text": "泌阳县",
      "value": 5113
    }, {
      "text": "遂平县",
      "value": 5114
    }, {
      "text": "西平县",
      "value": 5115
    }, {
      "text": "上蔡县",
      "value": 5116
    }, {
      "text": "汝南县",
      "value": 5117
    }, {
      "text": "平舆县",
      "value": 5118
    }, {
      "text": "新蔡县",
      "value": 5119
    }, {
      "text": "正阳县",
      "value": 5121
    }]
  }, {
    "text": "信阳市",
    "value": 1359,
    "children": [{
      "text": "浉河区",
      "value": 5151
    }, {
      "text": "息  县",
      "value": 5152
    }, {
      "text": "淮滨县",
      "value": 5153
    }, {
      "text": "潢川县",
      "value": 5155
    }, {
      "text": "光山县",
      "value": 5156
    }, {
      "text": "固始县",
      "value": 5157
    }, {
      "text": "商城县",
      "value": 5158
    }, {
      "text": "罗山县",
      "value": 5159
    }, {
      "text": "新  县",
      "value": 5161
    }, {
      "text": "平桥区",
      "value": 5162
    }]
  }, {
    "text": "郑州市",
    "value": 1343,
    "children": [{
      "text": "荥阳市",
      "value": 4911
    }, {
      "text": "中牟县",
      "value": 4912
    }, {
      "text": "新郑市",
      "value": 4913
    }, {
      "text": "巩义市",
      "value": 4914
    }, {
      "text": "登封市",
      "value": 4915
    }, {
      "text": "新密市",
      "value": 4916
    }, {
      "text": "中原区",
      "value": 4917
    }, {
      "text": "二七区",
      "value": 4918
    }, {
      "text": "管城回族区",
      "value": 4919
    }, {
      "text": "金水区",
      "value": 5071
    }, {
      "text": "上街区",
      "value": 5072
    }, {
      "text": "惠济区",
      "value": 5073
    }]
  }, {
    "text": "安阳市",
    "value": 1347,
    "children": [{
      "text": "安阳县",
      "value": 4962
    }, {
      "text": "汤阴县",
      "value": 4963
    }, {
      "text": "滑  县",
      "value": 4964
    }, {
      "text": "内黄县",
      "value": 4965
    }, {
      "text": "北关区",
      "value": 4967
    }, {
      "text": "殷都区",
      "value": 4968
    }, {
      "text": "龙安区",
      "value": 4969
    }, {
      "text": "林州市",
      "value": 4961
    }, {
      "text": "文峰区",
      "value": 4966
    }]
  }, {
    "text": "焦作市",
    "value": 1350,
    "children": [{
      "text": "修武县",
      "value": 5011
    }, {
      "text": "武陟县",
      "value": 5013
    }, {
      "text": "沁阳市",
      "value": 5014
    }, {
      "text": "温  县",
      "value": 5015
    }, {
      "text": "孟州市",
      "value": 5016
    }, {
      "text": "解放区",
      "value": 5018
    }, {
      "text": "中站区",
      "value": 5019
    }, {
      "text": "马村区",
      "value": 5181
    }, {
      "text": "山阳区",
      "value": 5182
    }, {
      "text": "博爱县",
      "value": 5012
    }, {
      "text": "济源市（省直辖）",
      "value": 5017
    }]
  }, {
    "text": "三门峡市",
    "value": 1354,
    "children": [{
      "text": "渑池县",
      "value": 5051
    }, {
      "text": "灵宝市",
      "value": 5053
    }, {
      "text": "卢氏县",
      "value": 5054
    }, {
      "text": "义马市",
      "value": 5055
    }, {
      "text": "陕  县",
      "value": 5052
    }, {
      "text": "湖滨区",
      "value": 5056
    }]
  }, {
    "text": "南阳市",
    "value": 1358,
    "children": [{
      "text": "宛城区",
      "value": 5131
    }, {
      "text": "邓州市",
      "value": 5132
    }, {
      "text": "南召县",
      "value": 5133
    }, {
      "text": "方城县",
      "value": 5134
    }, {
      "text": "西峡县",
      "value": 5135
    }, {
      "text": "卧龙区",
      "value": 5136
    }, {
      "text": "镇平县",
      "value": 5137
    }, {
      "text": "内乡县",
      "value": 5138
    }, {
      "text": "淅川县",
      "value": 5139
    }, {
      "text": "社旗县",
      "value": 5141
    }, {
      "text": "唐河县",
      "value": 5142
    }, {
      "text": "新野县",
      "value": 5143
    }, {
      "text": "桐柏县",
      "value": 5144
    }]
  }]
}, {
  "text": "湖北省",
  "value": 30,
  "children": [{
    "text": "武汉市",
    "value": 1360,
    "children": [{
      "text": "江岸区",
      "value": 5211
    }, {
      "text": "江汉区",
      "value": 5212
    }, {
      "text": "硚口区",
      "value": 5213
    }, {
      "text": "汉阳区",
      "value": 5214
    }, {
      "text": "武昌区",
      "value": 5215
    }, {
      "text": "青山区",
      "value": 5216
    }, {
      "text": "洪山区",
      "value": 5217
    }, {
      "text": "东西湖区",
      "value": 5218
    }, {
      "text": "汉南区",
      "value": 5219
    }, {
      "text": "蔡甸区",
      "value": 5391
    }, {
      "text": "江夏区",
      "value": 5392
    }, {
      "text": "黄陂区",
      "value": 5393
    }, {
      "text": "新洲区",
      "value": 5394
    }]
  }, {
    "text": "黄石市",
    "value": 1361,
    "children": [{
      "text": "大冶市",
      "value": 5221
    }, {
      "text": "阳新县",
      "value": 5222
    }, {
      "text": "黄石港区",
      "value": 5223
    }, {
      "text": "西塞山区",
      "value": 5224
    }, {
      "text": "下陆区",
      "value": 5225
    }, {
      "text": "铁山区",
      "value": 5226
    }]
  }, {
    "text": "宜昌市",
    "value": 1363,
    "children": [{
      "text": "宜都市",
      "value": 5251
    }, {
      "text": "当阳市",
      "value": 5262
    }, {
      "text": "枝江市",
      "value": 5264
    }, {
      "text": "远安县",
      "value": 5265
    }, {
      "text": "兴山县",
      "value": 5266
    }, {
      "text": "秭归县",
      "value": 5267
    }, {
      "text": "长阳土家族自治县",
      "value": 5268
    }, {
      "text": "五峰土家族自治县",
      "value": 5269
    }, {
      "text": "西陵区",
      "value": 5421
    }, {
      "text": "伍家岗区",
      "value": 5422
    }, {
      "text": "点军区",
      "value": 5423
    }, {
      "text": "猇亭区",
      "value": 5424
    }, {
      "text": "夷陵区",
      "value": 5425
    }]
  }, {
    "text": "随州市",
    "value": 1364,
    "children": [{
      "text": "广水市",
      "value": 5271
    }, {
      "text": "随  县",
      "value": 5272
    }, {
      "text": "曾都区",
      "value": 5273
    }]
  }, {
    "text": "襄阳市",
    "value": 1365,
    "children": [{
      "text": "襄城区",
      "value": 5281
    }, {
      "text": "宜城市",
      "value": 5282
    }, {
      "text": "南漳县",
      "value": 5283
    }, {
      "text": "谷城县",
      "value": 5284
    }, {
      "text": "保康县",
      "value": 5285
    }, {
      "text": "襄州区",
      "value": 5286
    }, {
      "text": "老河口市",
      "value": 5287
    }, {
      "text": "枣阳市",
      "value": 5288
    }, {
      "text": "樊城区",
      "value": 5289
    }]
  }, {
    "text": "荆门市",
    "value": 1367,
    "children": [{
      "text": "京山市",
      "value": 5321
    }, {
      "text": "沙洋县",
      "value": 5322
    }, {
      "text": "钟祥市",
      "value": 5323
    }, {
      "text": "东宝区",
      "value": 5324
    }, {
      "text": "掇刀区",
      "value": 5325
    }]
  }, {
    "text": "黄冈市",
    "value": 1368,
    "children": [{
      "text": "麻城市",
      "value": 5331
    }, {
      "text": "武穴市",
      "value": 5332
    }, {
      "text": "团风县",
      "value": 5333
    }, {
      "text": "红安县",
      "value": 5334
    }, {
      "text": "罗田县",
      "value": 5335
    }, {
      "text": "英山县",
      "value": 5336
    }, {
      "text": "浠水县",
      "value": 5337
    }, {
      "text": "蕲春县",
      "value": 5338
    }, {
      "text": "黄梅县",
      "value": 5339
    }, {
      "text": "黄州区",
      "value": 5341
    }]
  }, {
    "text": "孝感市",
    "value": 1369,
    "children": [{
      "text": "孝昌县",
      "value": 5351
    }, {
      "text": "应城市",
      "value": 5352
    }, {
      "text": "安陆市",
      "value": 5353
    }, {
      "text": "孝南区",
      "value": 5354
    }, {
      "text": "大悟县",
      "value": 5355
    }, {
      "text": "云梦县",
      "value": 5356
    }, {
      "text": "汉川市",
      "value": 5357
    }]
  }, {
    "text": "咸宁市",
    "value": 1370,
    "children": [{
      "text": "咸安区",
      "value": 5361
    }, {
      "text": "嘉鱼县",
      "value": 5363
    }, {
      "text": "通城县",
      "value": 5364
    }, {
      "text": "崇阳县",
      "value": 5365
    }, {
      "text": "通山县",
      "value": 5366
    }, {
      "text": "赤壁市",
      "value": 5367
    }]
  }, {
    "text": "荆州市",
    "value": 1371,
    "children": [{
      "text": "仙桃市（省直辖）",
      "value": 5371
    }, {
      "text": "石首市",
      "value": 5372
    }, {
      "text": "洪湖市",
      "value": 5373
    }, {
      "text": "天门市（省直辖）",
      "value": 5374
    }, {
      "text": "潜江市（省直辖）",
      "value": 5375
    }, {
      "text": "江陵县",
      "value": 5376
    }, {
      "text": "松滋市",
      "value": 5377
    }, {
      "text": "公安县",
      "value": 5378
    }, {
      "text": "监利县",
      "value": 5379
    }, {
      "text": "沙市区",
      "value": 5381
    }, {
      "text": "荆州区",
      "value": 5382
    }]
  }, {
    "text": "恩施土家族苗族自治州",
    "value": 1372,
    "children": [{
      "text": "恩施市",
      "value": 5411
    }, {
      "text": "建始县",
      "value": 5413
    }, {
      "text": "宣恩县",
      "value": 5415
    }, {
      "text": "来凤县",
      "value": 5417
    }, {
      "text": "利川市",
      "value": 5412
    }, {
      "text": "巴东县",
      "value": 5414
    }, {
      "text": "咸丰县",
      "value": 5416
    }, {
      "text": "鹤峰县",
      "value": 5418
    }]
  }, {
    "text": "十堰市",
    "value": 1362,
    "children": [{
      "text": "郧阳区",
      "value": 5231
    }, {
      "text": "郧西县",
      "value": 5232
    }, {
      "text": "竹山县",
      "value": 5233
    }, {
      "text": "竹溪县",
      "value": 5234
    }, {
      "text": "房  县",
      "value": 5235
    }, {
      "text": "丹江口市",
      "value": 5236
    }, {
      "text": "茅箭区",
      "value": 5237
    }, {
      "text": "张湾区",
      "value": 5238
    }]
  }, {
    "text": "鄂州市",
    "value": 1366,
    "children": [{
      "text": "神农架林区（省直辖）",
      "value": 5311
    }, {
      "text": "梁子湖区",
      "value": 5312
    }, {
      "text": "华容区",
      "value": 5313
    }, {
      "text": "鄂城区",
      "value": 5314
    }]
  }]
}, {
  "text": "湖南省",
  "value": 31,
  "children": [{
    "text": "长沙市",
    "value": 1373,
    "children": [{
      "text": "长沙县",
      "value": 5511
    }, {
      "text": "岳麓区",
      "value": 5512
    }, {
      "text": "浏阳市",
      "value": 5513
    }, {
      "text": "宁乡市",
      "value": 5514
    }, {
      "text": "芙蓉区",
      "value": 5515
    }, {
      "text": "天心区",
      "value": 5516
    }, {
      "text": "雨花区",
      "value": 5518
    }, {
      "text": "望城区",
      "value": 5519
    }, {
      "text": "开福区",
      "value": 5517
    }]
  }, {
    "text": "株洲市",
    "value": 1374,
    "children": [{
      "text": "渌口区",
      "value": 5521
    }, {
      "text": "茶陵县",
      "value": 5523
    }, {
      "text": "炎陵县",
      "value": 5524
    }, {
      "text": "醴陵市",
      "value": 5525
    }, {
      "text": "荷塘区",
      "value": 5526
    }, {
      "text": "石峰区",
      "value": 5528
    }, {
      "text": "天元区",
      "value": 5529
    }, {
      "text": "攸　县",
      "value": 5522
    }, {
      "text": "芦淞区",
      "value": 5527
    }]
  }, {
    "text": "湘潭市",
    "value": 1375,
    "children": [{
      "text": "湘潭县",
      "value": 5531
    }, {
      "text": "韶山市",
      "value": 5533
    }, {
      "text": "雨湖区",
      "value": 5534
    }, {
      "text": "岳塘区",
      "value": 5535
    }, {
      "text": "湘乡市",
      "value": 5532
    }]
  }, {
    "text": "衡阳市",
    "value": 1376,
    "children": [{
      "text": "衡阳县",
      "value": 5541
    }, {
      "text": "衡山县",
      "value": 5543
    }, {
      "text": "衡东县",
      "value": 5544
    }, {
      "text": "常宁市",
      "value": 5545
    }, {
      "text": "耒阳市",
      "value": 5547
    }, {
      "text": "珠晖区",
      "value": 5548
    }, {
      "text": "雁峰区",
      "value": 5549
    }, {
      "text": "石鼓区",
      "value": 5711
    }, {
      "text": "南岳区",
      "value": 5713
    }, {
      "text": "衡南县",
      "value": 5542
    }, {
      "text": "祁东县",
      "value": 5546
    }, {
      "text": "蒸湘区",
      "value": 5712
    }]
  }, {
    "text": "邵阳市",
    "value": 1377,
    "children": [{
      "text": "邵东县",
      "value": 5551
    }, {
      "text": "新邵县",
      "value": 5552
    }, {
      "text": "隆回县",
      "value": 5554
    }, {
      "text": "洞口县",
      "value": 5555
    }, {
      "text": "武冈市",
      "value": 5556
    }, {
      "text": "绥宁县",
      "value": 5557
    }, {
      "text": "城步苗族自治县",
      "value": 5559
    }, {
      "text": "双清区",
      "value": 5561
    }, {
      "text": "大祥区",
      "value": 5562
    }, {
      "text": "邵阳县",
      "value": 5553
    }, {
      "text": "新宁县",
      "value": 5558
    }, {
      "text": "北塔区",
      "value": 5563
    }]
  }, {
    "text": "岳阳市",
    "value": 1378,
    "children": [{
      "text": "岳阳县",
      "value": 5571
    }, {
      "text": "临湘市",
      "value": 5572
    }, {
      "text": "华容县",
      "value": 5573
    }, {
      "text": "湘阴县",
      "value": 5574
    }, {
      "text": "汨罗市",
      "value": 5576
    }, {
      "text": "岳阳楼区",
      "value": 5577
    }, {
      "text": "云溪区",
      "value": 5578
    }, {
      "text": "平江县",
      "value": 5575
    }, {
      "text": "君山区",
      "value": 5579
    }]
  }, {
    "text": "常德市",
    "value": 1379,
    "children": [{
      "text": "安乡县",
      "value": 5581
    }, {
      "text": "汉寿县",
      "value": 5582
    }, {
      "text": "澧　县",
      "value": 5583
    }, {
      "text": "临澧县",
      "value": 5584
    }, {
      "text": "石门县",
      "value": 5586
    }, {
      "text": "津市市",
      "value": 5587
    }, {
      "text": "武陵区",
      "value": 5588
    }, {
      "text": "桃源县",
      "value": 5585
    }, {
      "text": "鼎城区",
      "value": 5589
    }]
  }, {
    "text": "张家界市",
    "value": 1380,
    "children": [{
      "text": "慈利县",
      "value": 5591
    }, {
      "text": "桑植县",
      "value": 5592
    }, {
      "text": "永定区",
      "value": 5593
    }, {
      "text": "武陵源区",
      "value": 5594
    }]
  }, {
    "text": "益阳市",
    "value": 1381,
    "children": [{
      "text": "沅江市",
      "value": 5612
    }, {
      "text": "南  县",
      "value": 5614
    }, {
      "text": "桃江县",
      "value": 5615
    }, {
      "text": "资阳区",
      "value": 5617
    }, {
      "text": "赫山区",
      "value": 5618
    }, {
      "text": "安化县",
      "value": 5616
    }]
  }, {
    "text": "娄底市",
    "value": 1382,
    "children": [{
      "text": "娄星区",
      "value": 5621
    }, {
      "text": "冷水江市",
      "value": 5622
    }, {
      "text": "双峰县",
      "value": 5624
    }, {
      "text": "新化县",
      "value": 5625
    }, {
      "text": "涟源市",
      "value": 5623
    }]
  }, {
    "text": "郴州市",
    "value": 1383,
    "children": [{
      "text": "北湖区",
      "value": 5631
    }, {
      "text": "苏仙区",
      "value": 5633
    }, {
      "text": "桂阳县",
      "value": 5634
    }, {
      "text": "永兴县",
      "value": 5635
    }, {
      "text": "宜章县",
      "value": 5636
    }, {
      "text": "临武县",
      "value": 5638
    }, {
      "text": "汝城县",
      "value": 5639
    }, {
      "text": "桂东县",
      "value": 5641
    }, {
      "text": "安仁县",
      "value": 5642
    }, {
      "text": "资兴市",
      "value": 5632
    }, {
      "text": "嘉禾县",
      "value": 5637
    }]
  }, {
    "text": "永州市",
    "value": 1384,
    "children": [{
      "text": "东安县",
      "value": 5653
    }, {
      "text": "道  县",
      "value": 5654
    }, {
      "text": "宁远县",
      "value": 5655
    }, {
      "text": "江永县",
      "value": 5656
    }, {
      "text": "江华瑶族自治县",
      "value": 5657
    }, {
      "text": "蓝山县",
      "value": 5658
    }, {
      "text": "新田县",
      "value": 5659
    }, {
      "text": "双牌县",
      "value": 5661
    }, {
      "text": "祁阳县",
      "value": 5662
    }, {
      "text": "零陵区",
      "value": 5663
    }, {
      "text": "冷水滩区",
      "value": 5664
    }]
  }, {
    "text": "怀化市",
    "value": 1385,
    "children": [{
      "text": "芷江侗族自治县",
      "value": 5679
    }, {
      "text": "会同县",
      "value": 5681
    }, {
      "text": "靖州苗族侗族自治县",
      "value": 5682
    }, {
      "text": "通道侗族自治县",
      "value": 5683
    }, {
      "text": "中方县",
      "value": 5684
    }, {
      "text": "鹤城区",
      "value": 5671
    }, {
      "text": "洪江市",
      "value": 5672
    }, {
      "text": "沅陵县",
      "value": 5674
    }, {
      "text": "辰溪县",
      "value": 5675
    }, {
      "text": "溆浦县",
      "value": 5676
    }, {
      "text": "麻阳苗族自治县",
      "value": 5677
    }, {
      "text": "新晃侗族自治县",
      "value": 5678
    }]
  }, {
    "text": "湘西土家族苗族自治州",
    "value": 967,
    "children": [{
      "text": "吉首市",
      "value": 5691
    }, {
      "text": "泸溪县",
      "value": 5692
    }, {
      "text": "凤凰县",
      "value": 5693
    }, {
      "text": "花垣县",
      "value": 5694
    }, {
      "text": "保靖县",
      "value": 5695
    }, {
      "text": "古丈县",
      "value": 5696
    }, {
      "text": "永顺县",
      "value": 5697
    }, {
      "text": "龙山县",
      "value": 5698
    }]
  }]
}]